/* INTEGY V577 - canonical Traxxas routing + collection-aware stock ownership + conservative live verification + Pinion alias repair.
   Shopify remains the live inventory authority; V42 provides current compatibility/classification candidates in V648.
   Consolidated from the proven V481 owner; V498 preserves filtered visibility and removes
   unverified title/tag phrases from buyer-facing filter choices.

   Legacy note:
   Extends the proven canonical-index resolver with explicit single-select
   filter groups, URL repair, accessible chips, and conversion-safe empty states. */
(function () {
  'use strict';
  var FILTER_PAGE_SIZE = Number(window.INTEGY_PRODUCTS_PER_PAGE || 72);

  if (window.IntegyV564LegacyRedirecting || !window.INTEGY_V429_FILTER_OWNER || window.IntegyV501FilterOwner) return;

  var root = document.documentElement;
  var indexPromise = null;
  var applying = false;
  window.IntegyV501FilterIntegrity = window.IntegyV498FilterIntegrity = { version: 'V577', membershipOwner: 'shopify-native-except-audited-indexed-stock' };
  var targetCollections = {
    'all': true,
    'hop-up-parts-for-losi-1-18-mini-lmt-4x4-brushed-monster-truck-rtr': true,
    'hop-up-parts-for-losi-1-18-mini-lmt-4x4-brushed-monster-truck': true,
    'hop-up-parts-for-losi-1-18-4x4-mini-lmt-monster-truck': true,
    'hop-up-parts-for-arrma-1-5-kraton-8s-blx': true,
    'hop-up-parts-for-traxxas-1-18-trx-4m-scale-and-trail-crawler': true,
    'hop-up-parts-for-traxxas-trx-4m-crawler': true,
    'hop-up-parts-for-traxxas-1-18-trx-4m-crawler': true,
    'hop-up-parts-for-traxxas': true,
    'hop-up-parts-for-traxxas-mini-xrt': true,
    'hop-up-parts-for-traxxas-mini-slash-4x4': true,
    'hopups-for-traxxas': true,
    'parts-for-traxxas': true,
    'hopups-for-axial': true,
    'hop-up-parts-for-axial': true,
    'parts-for-axial': true,
    'hop-up-parts-for-hpi-racing': true,
    'hopups-for-hpi-racing': true,
    'parts-for-hpi-racing': true,
    'parts-for-hpi': true,
    'hopups-for-arrma': true,
    'hop-up-parts-for-arrma': true,
    'parts-for-arrma': true,
    'arrma': true,
    'hop-up-parts-for-arrma-1-8-mojave-4x4-4s-blx': true,
    'hop-up-parts-for-arrma-1-8-infraction-3s-blx-all-road': true,
    'hopups-for-tamiya': true,
    'hop-up-parts-for-tamiya': true,
    'parts-for-tamiya': true,
    'tamiya': true,
    'hopups-for-losi': true,
    'hop-up-parts-for-losi': true,
    'parts-for-losi': true,
    'losi': true,
    'all-integy-hop-up-parts': true,
    'rc-tools': true,
    'all-rc-tools-tool-sets-and-accessories': true,
    'rc-electronics': true,
    'cars-trucks': true,
    'tesla-accessories': true,
    'tires-wheels-hex-inserts-for-rc-cars-trucks': true,
    'pinion-gears-for-rc': true,
    'pinion-gears-for-rc-cars-and-trucks': true,
    'pinion-gears-for-rc-cars-trucks': true,
    'pinion-and-spur-gears-for-1-5-1-8-1-10-1-12-1-18-rc': true
  };
  // V362: use query-backed canonical filters for indexed collections.
  // Shopify strips many canonical-only tag URLs before the resolver can run
  // (example: /hopups-for-tamiya/ball-link redirects to the base collection).
  // The query route keeps the user on the collection so this script can render
  // the V35 canonical-index result set reliably.
  // V536: Shopify does not expose collection.filters on very large collections.
  // These two master catalogs have dedicated, recently refreshed V535 indexes whose
  // collection membership closely tracks the live Shopify collections. They can
  // therefore own stock-only filtering when native availability is unavailable.
  // Do not broaden this list without comparing indexed membership to the live catalog.
  // V538: indexed collection pages replace/reorder the product grid after a browser
  // back navigation. Native browser scroll restoration happens before that asynchronous
  // rebuild, so the old scroll offset can be lost. Remember the clicked product card
  // and its viewport position, then restore it only after the canonical grid is stable.
  var returnPositionStorageKey = 'integy:v538:collection-return';
  var returnRestoreState = null;
  var returnRestoreTimers = [];
  var returnRestoreSucceeded = false;
  var returnRestoreDeadline = 0;

  function v626RootPath() {
    try {
      var rootPath = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
      if (rootPath) return rootPath.charAt(rootPath.length - 1) === '/' ? rootPath : rootPath + '/';
    } catch (error) {}
    return '/';
  }

  function v626LocalizedPath(path) {
    return v626RootPath() + String(path || '').replace(/^\/+/, '');
  }

  function currentCollectionUrl() {
    return String(location.pathname || '') + String(location.search || '');
  }

  function navigationIsBackForward() {
    try {
      var entries = window.performance && performance.getEntriesByType ? performance.getEntriesByType('navigation') : [];
      if (entries && entries[0] && entries[0].type === 'back_forward') return true;
      return !!(window.performance && performance.navigation && performance.navigation.type === 2);
    } catch (error) {
      return false;
    }
  }

  function readReturnPosition() {
    try {
      var raw = sessionStorage.getItem(returnPositionStorageKey);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || data.version !== 1 || data.collectionUrl !== currentCollectionUrl()) return null;
      if (!data.timestamp || Date.now() - data.timestamp > 30 * 60 * 1000) {
        sessionStorage.removeItem(returnPositionStorageKey);
        return null;
      }
      return data;
    } catch (error) {
      return null;
    }
  }

  function saveReturnPosition(event) {
    if (!document.body || !document.body.classList.contains('template-collection')) return;
    if (event && (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)) return;
    var target = event && event.target && event.target.closest ? event.target.closest('a[href*="/products/"]') : null;
    if (!target || target.target === '_blank') return;
    var grid = target.closest('[data-productgrid-items], .productgrid--items');
    var card = target.closest('[data-product-item], .productgrid--item');
    if (!grid || !card) return;
    var href = target.getAttribute('href') || '';
    var path = productPath(href);
    if (!path) return;
    var rect = card.getBoundingClientRect();
    var state = {
      version: 1,
      collectionUrl: currentCollectionUrl(),
      productPath: path,
      scrollY: Math.max(0, Math.round(window.scrollY || window.pageYOffset || 0)),
      viewportTop: Math.round(rect.top),
      timestamp: Date.now()
    };
    try { sessionStorage.setItem(returnPositionStorageKey, JSON.stringify(state)); } catch (error) {}
  }

  function clearReturnRestoreTimers() {
    returnRestoreTimers.forEach(function (timer) { window.clearTimeout(timer); });
    returnRestoreTimers = [];
  }

  function armReturnPositionRestore(force) {
    if (!force && !navigationIsBackForward()) return false;
    var state = readReturnPosition();
    if (!state) return false;
    clearReturnRestoreTimers();
    returnRestoreState = state;
    returnRestoreSucceeded = false;
    returnRestoreDeadline = Date.now() + 2200;
    return true;
  }

  function matchingReturnCard(grid, state) {
    if (!grid || !state || !state.productPath) return null;
    var cards = qsa('[data-product-item], .productgrid--item', grid);
    for (var i = 0; i < cards.length; i += 1) {
      var anchor = qs('a[href*="/products/"]', cards[i]);
      if (anchor && productPath(anchor.getAttribute('href') || '') === state.productPath) return cards[i];
    }
    return null;
  }

  function restoreReturnPosition(grid) {
    var state = returnRestoreState;
    if (!state || state.collectionUrl !== currentCollectionUrl()) return false;
    if (Date.now() > returnRestoreDeadline) return false;
    grid = grid || qs('[data-productgrid-items], .productgrid--items');
    var card = matchingReturnCard(grid, state);
    var nextY = Number(state.scrollY || 0);
    if (card) {
      var rect = card.getBoundingClientRect();
      var savedTop = Number(state.viewportTop);
      if (!isFinite(savedTop)) savedTop = 120;
      nextY = Math.max(0, (window.scrollY || window.pageYOffset || 0) + rect.top - savedTop);
    }
    window.scrollTo(0, Math.round(nextY));
    returnRestoreSucceeded = true;
    return true;
  }

  function scheduleReturnPositionRestore(grid) {
    if (!returnRestoreState) return;
    clearReturnRestoreTimers();
    [0, 40, 120, 300, 650, 1100, 1700].forEach(function (delay, index) {
      var timer = window.setTimeout(function () {
        if (!returnRestoreState) return;
        restoreReturnPosition(grid || qs('[data-productgrid-items], .productgrid--items'));
        if (index === 6 || Date.now() > returnRestoreDeadline) {
          if (returnRestoreSucceeded) {
            try { sessionStorage.removeItem(returnPositionStorageKey); } catch (error) {}
          }
          returnRestoreState = null;
          clearReturnRestoreTimers();
        }
      }, delay);
      returnRestoreTimers.push(timer);
    });
  }

  if (navigationIsBackForward()) armReturnPositionRestore(true);

  // V576 stock ownership: Shopify's availability parameter is not reliable on
  // /collections/all, All Integy Hop-Up Parts, or the active Traxxas handles.
  // Use V42 only as a candidate/ordering snapshot and live-verify every rendered
  // indexed stock card against Shopify product JSON before it is allowed to show.
  // V656: Shopify is authoritative again for individual model collection membership
  // and native availability. The old V648 exceptions became stale as backend collection
  // assignments changed (Mini LMT and Kraton gained valid products; TRX-4M's old V42
  // candidate set became broader than the current Shopify collection). V42 remains the
  // facet/index source after a buyer explicitly selects a custom Integy filter.
  var forcedIndexedMembershipCollections = {};

  var indexedStockCollections = {
    // V696: /collections/all is owned by the live row-level availability owner.
    // Keep indexed ownership only for the audited compatibility catalogs below.
    'all-integy-hop-up-parts': true,
    'hopups-for-traxxas': true,
    'hop-up-parts-for-traxxas': true,
    'parts-for-traxxas': true,
    'pinion-and-spur-gears-for-1-5-1-8-1-10-1-12-1-18-rc': true
  };

  var queryFilterCollections = {
    'hop-up-parts-for-traxxas': true,
    'hop-up-parts-for-traxxas-mini-xrt': true,
    'hop-up-parts-for-traxxas-mini-slash-4x4': true,
    'hopups-for-traxxas': true,
    'parts-for-traxxas': true,
    'hopups-for-axial': true,
    'hop-up-parts-for-axial': true,
    'parts-for-axial': true,
    'hop-up-parts-for-hpi-racing': true,
    'hopups-for-hpi-racing': true,
    'parts-for-hpi-racing': true,
    'parts-for-hpi': true,
    'hopups-for-arrma': true,
    'hop-up-parts-for-arrma': true,
    'parts-for-arrma': true,
    'arrma': true,
    'hop-up-parts-for-arrma-1-8-mojave-4x4-4s-blx': true,
    'hop-up-parts-for-arrma-1-8-infraction-3s-blx-all-road': true,
    'hopups-for-tamiya': true,
    'hop-up-parts-for-tamiya': true,
    'parts-for-tamiya': true,
    'tamiya': true,
    'hopups-for-losi': true,
    'hop-up-parts-for-losi': true,
    'parts-for-losi': true,
    'losi': true,
    'all-integy-hop-up-parts': true,
    'rc-tools': true,
    'all-rc-tools-tool-sets-and-accessories': true,
    'rc-electronics': true,
    'tesla-accessories': true,
    'tires-wheels-hex-inserts-for-rc-cars-trucks': true,
    'pinion-gears-for-rc': true,
    'pinion-gears-for-rc-cars-and-trucks': true,
    'pinion-gears-for-rc-cars-trucks': true,
    'pinion-and-spur-gears-for-1-5-1-8-1-10-1-12-1-18-rc': true
  };

  function nativeAvailabilityDeclared() {
    var shell = qs('.productgrid--outer');
    if (!shell) return false;
    return shell.getAttribute('data-integy-v449-native-availability') === 'true';
  }

  function indexedStockOwnerForCollection(handle) {
    handle = handleize(handle);
    /* V636: the legacy Pinion & Spur master collection stays Shopify-native on
       its base route. Only canonical query-filter routes use the indexed owner,
       avoiding a scope change for ordinary browsing while fixing legacy /1-18. */
    if (handle === 'pinion-and-spur-gears-for-1-5-1-8-1-10-1-12-1-18-rc' && !queryFilterTags().length) return false;
    return !!indexedStockCollections[handle];
  }

  function ownsStockForCurrentCollection() {
    var current = pathData();
    if (!current.collection || !targetCollections[current.collection]) return false;
    // Any active canonical/index filter is already rendered by this owner, so a
    // second page-local stock hider must not touch those cards.
    if (current.tags && current.tags.length) return true;
    if (!indexedStockOwnerForCollection(current.collection)) return false;
    return requestedStockMode() !== 'all';
  }

  function canonicalCollectionHandle(handle) {
    handle = handleize(handle);
    if (handle === 'hop-up-parts-for-traxxas' || handle === 'parts-for-traxxas') return 'hopups-for-traxxas';
    return handle;
  }

  function queryFilterCollection(handle) {
    handle = canonicalCollectionHandle(handle);
    if (queryFilterCollections[handle]) return true;
    return !!(targetCollections[handle] && handle !== 'cars-trucks');
  }

  function queryFilterTags() {
    try {
      var params = new URLSearchParams(location.search || '');
      var raw = params.get('integy_filter') || params.get('integy_filters') || params.get('integy_tag_filter') || '';
      raw = String(raw || '').replace(/\s+/g, '+');
      return raw ? unique(raw.split('+')) : [];
    } catch (error) {
      return [];
    }
  }

  // V365: never offer Weight Scale as a hop-up/vehicle filter. In RC titles,
  // "scale" usually means 1/10 Scale, Scale Crawler, Scale & Trail, or Scale Model,
  // not a measuring scale. The canonical index is also cleaned, but this defensive
  // suppression prevents older/fallback rows from briefly surfacing the bad option.
  var falsePositiveCollectionHandles = {
    'hop-up-parts-for-traxxas': { 'weight-scale': true },
    'hopups-for-traxxas': { 'weight-scale': true },
    'parts-for-traxxas': { 'weight-scale': true },
    'hopups-for-axial': { 'weight-scale': true },
    'hop-up-parts-for-axial': { 'weight-scale': true },
    'parts-for-axial': { 'weight-scale': true },
    'hopups-for-arrma': { 'weight-scale': true },
    'hop-up-parts-for-arrma': { 'weight-scale': true },
    'parts-for-arrma': { 'weight-scale': true },
    'arrma': { 'weight-scale': true },
    'hop-up-parts-for-hpi-racing': { 'weight-scale': true },
    'hopups-for-hpi-racing': { 'weight-scale': true },
    'parts-for-hpi-racing': { 'weight-scale': true },
    'parts-for-hpi': { 'weight-scale': true },
    'hopups-for-losi': { 'weight-scale': true },
    'hop-up-parts-for-losi': { 'weight-scale': true },
    'parts-for-losi': { 'weight-scale': true },
    'losi': { 'weight-scale': true },
    'tires-wheels-hex-inserts-for-rc-cars-trucks': { 'weight-scale': true },
    'cars-trucks': { 'weight-scale': true },
    'hopups-for-tamiya': {
      'weight-scale': true,
      truck: true
    },
    'hop-up-parts-for-tamiya': {
      'weight-scale': true,
      truck: true
    },
    'parts-for-tamiya': {
      'weight-scale': true,
      truck: true
    },
    tamiya: {
      'weight-scale': true,
      truck: true
    }
  };

  var suppressedHandles = {
    mount: true,
    '4wd': true,
    box: true,
    chassis: true,
    pin: true,
    suspension: true,
    link: true,
    glue: true,
    'hinge-pin': true,
    nut: true,
    shaft: true,
    'all-terrain': true,
    'power-supply': true,
    boat: true,
    screws: true,
    'suspension-hanger': true,
    '8x8': true,
    '6x6': true,
    'rc-truck': true,
    decal: true,
    shim: true,
    spacers: true,
    discharger: true,
    tape: true,
    'wheel-nut': true,
    tire: true,
    adapter: true,
    parts: true,
    accessories: true,
    used: true,
    'open-box': true,
    'scratch-dent': true
  };
  var preferredOrder = [
    '0-6-mod','0-8-mod','1-mod','32-pitch','48-pitch','64-pitch',
    '2mm-bore','3-17mm-bore','5mm-bore','8mm-bore','steel','aluminum',
    'model-3','model-y','model-s','model-x','storage-box','tray','organizer','trunk-mat','floor-mat','cover','door-handle',
    'brace',
    'bumper',
    'skid-plate',
    'body-mount',
    'body',
    'chassis-plate',
    'tie-rod',
    'rod-end',
    'ball-end',
    'ball-link',
    'linkage',
    'servo-horn',
    'servo',
    'receiver-box',
    'turnbuckle',
    'suspension-link',
    'suspension-arm',
    'shock-shaft',
    'shock-tool',
    'shock',
    'shock-tower',
    'hub-carrier',
    'caster-block',
    'steering-block',
    'bearing',
    'gear',
    'pinion-gear',
    'spur-gear',
    'gearbox',
    'differential',
    'drive-shaft',
    'esc',
    'receiver',
    'radio-controller',
    'motor',
    'gyro',
    'cooling-fan',
    'led-light',
    'connector',
    'battery-meter',
    'discharger',
    'charger-accessory',
    'power-supply',
    'starter-box',
    'weight-scale',
    'steering-wheel',
    'wheel-hex',
    'wheel',
    'tire',
    'premounted-set',
    'foam-insert',
    'wheel-nut',
    'wheel-accessory',
    '12mm-hex',
    '14mm-hex',
    '17mm-hex',
    '23mm-hex',
    '1-4',
    '1-5',
    '1-6',
    '1-7',
    '1-8',
    '1-10',
    '1-12',
    '1-14',
    '1-16',
    '1-18',
    '1-24',
    '1-28',
    '1-36',
    'buggy',
    'truggy',
    'short-course',
    'monster-truck',
    'crawler',
    'drift',
    'touring',
    'f1',
    'm-chassis',
    'micro-mini',
    'front',
    'rear',
    'hex-wrench',
    'nut-driver',
    'screwdriver',
    'body-reamer',
    'setup-station',
    'tool-set',
    'turnbuckle-tool',
    'wheel-nut-wrench',
    'cutting-tool',
    'soldering-tool',
    'pit-tool',
    'tool-bag',
    'oil-fluid',
    'adhesive-tape',
    'motor-tool',
    'stand',
    'rtr',
    'artr',
    'kit',
    'truck',
    'semi-truck',
    '2wd',
    '4wd',
    '6x6',
    '8x8',
    'rtr-boats',
    'artr-boats',
    'boat-kits',
    'hull',
    'catamaran',
    'mono-hull',
    'jet-boat',
    'marine-esc',
    'brushless-motor',
    'brushed-motor',
    'motor-mount',
    'water-cooling',
    'cooling-jacket',
    'cooling-tube',
    'pump',
    'propeller',
    'jet-drive',
    'outdrive',
    'coupler',
    'stuffing-tube',
    'rudder',
    'trim-tab',
    'esc-switch',
    'battery-strap',
    'seal-boot',
    'hardware',
    'maintenance-tool',
    'prop-balancer',
    'spring',
    'axle',
    'titanium',
    'chrome',
    'black',
    'blue',
    'green',
    'grey',
    'gunmetal',
    'orange',
    'purple',
    'red',
    'silver',
    'yellow'
  ];

  var filterGroups = {
    pitch_module: ['0-6-mod','0-8-mod','1-mod','32-pitch','48-pitch','64-pitch'],
    bore: ['2mm-bore','3-17mm-bore','5mm-bore','8mm-bore'],
    material: ['steel','aluminum'],
    part_type: [
      'brace','bumper','skid-plate','body-mount','body','chassis-plate','tie-rod','rod-end','ball-end','ball-link','linkage',
      'servo-horn','servo','receiver-box','turnbuckle','suspension-link','suspension-arm','shock-shaft','shock-tool','shock','shock-tower',
      'hub-carrier','caster-block','steering-block','bearing','gear','pinion-gear','spur-gear','gearbox','differential','drive-shaft',
      'esc','receiver','radio-controller','motor','gyro','cooling-fan','led-light','connector','battery-meter','discharger','charger-accessory',
      'power-supply','starter-box','weight-scale','steering-wheel','wheel-hex','wheel','tire','premounted-set','foam-insert','wheel-nut',
      'wheel-accessory','12mm-hex','14mm-hex','17mm-hex','23mm-hex','hex-wrench','nut-driver','screwdriver','body-reamer','setup-station',
      'tool-set','turnbuckle-tool','wheel-nut-wrench','cutting-tool','soldering-tool','pit-tool','tool-bag','oil-fluid','adhesive-tape',
      'motor-tool','stand','storage-box','tray','organizer','trunk-mat','floor-mat','cover','door-handle','hull','catamaran','mono-hull','jet-boat','marine-esc','brushless-motor','brushed-motor','motor-mount',
      'water-cooling','cooling-jacket','cooling-tube','pump','propeller','jet-drive','outdrive','coupler','stuffing-tube','rudder','trim-tab',
      'esc-switch','battery-strap','seal-boot','hardware','maintenance-tool','prop-balancer','spring','axle'
    ],
    vehicle_model: ['model-3','model-y','model-s','model-x'],
    vehicle_type: ['buggy','truggy','short-course','monster-truck','crawler','drift','touring','f1','m-chassis','micro-mini','rtr','artr','kit','truck','semi-truck','rtr-boats','artr-boats','boat-kits'],
    drivetrain: ['2wd','4wd','6x6','8x8'],
    battery_system: ['2s','3s','4s','6s','8s','3s-blx','4s-blx','6s-blx','8s-blx'],
    color: ['black','blue','green','grey','gray','gunmetal','orange','purple','red','silver','yellow','chrome','gold','bronze','light-blue','dark-green'],
    availability: ['in-stock','available','out-of-stock','sold-out','pre-order'],
    sale_status: ['sale','on-sale','clearance','discount','scratch-dent','open-box']
  };

  /* V500 buyer-facing taxonomy contract. Unknown tags and internal vehicle-model
     aliases never enter the generic attribute list. Verified models remain in the
     separate menu-backed Compatible Models group. */
  var buyerVisibleGroups = {
    pitch_module: true,
    bore: true,
    material: true,
    part_type: true,
    scale: true,
    vehicle_type: true,
    drivetrain: true,
    battery_system: true,
    color: true,
    availability: false,
    sale_status: true
  };
  var groupLookup = Object.create(null);
  Object.keys(filterGroups).forEach(function (group) {
    filterGroups[group].forEach(function (handle) { groupLookup[handle] = group; });
  });

  function qs(selector, scope) {
    try { return (scope || document).querySelector(selector); } catch (error) { return null; }
  }

  function qsa(selector, scope) {
    try { return Array.prototype.slice.call((scope || document).querySelectorAll(selector)); } catch (error) { return []; }
  }

  function clean(value) {
    return String(value == null ? '' : value).replace(/\s+/g, ' ').trim();
  }

  function handleize(value) {
    value = clean(value).toLowerCase();
    try { value = value.normalize('NFKD').replace(/[\u0300-\u036f]/g, ''); } catch (error) {}
    return value
      .replace(/&/g, ' and ')
      .replace(/['\u2019]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function filterGroup(handle) {
    handle = handleize(handle);
    if (!handle || handle === 'front' || handle === 'rear' || handle === 'titanium') return '';
    if (groupLookup[handle]) return groupLookup[handle];
    if (/^1-\d{1,2}$/.test(handle)) return 'scale';
    /* V498: unknown imported tags are not vehicle models. Real model navigation is
       provided by the verified menu-backed Compatible Models section. */
    return '';
  }

  function normalizeGroupTags(index, tags) {
    var output = [];
    canonicalTags(index || {}, tags || []).forEach(function (handle) {
      var group = filterGroup(handle);
      if (group) output = output.filter(function (candidate) { return filterGroup(candidate) !== group; });
      output.push(handle);
    });
    return unique(output);
  }

  function nextTagsForSelection(index, active, handle, isActive) {
    active = normalizeGroupTags(index, active || []);
    handle = canonical(index || {}, handle);
    if (isActive) return active.filter(function (tag) { return tag !== handle; });
    var group = filterGroup(handle);
    if (group) active = active.filter(function (tag) { return filterGroup(tag) !== group; });
    active.push(handle);
    return unique(active);
  }

  function pathData() {
    var parts = String(location.pathname || '').split('/').filter(Boolean);
    var index = parts.indexOf('collections');
    if (index < 0 || !parts[index + 1]) return { collection: '', tags: [] };
    var collection = handleize(decodeURIComponent(parts[index + 1]));
    var queryTags = queryFilterTags();
    return {
      collection: collection,
      tags: queryTags.length
        ? queryTags
        : (parts[index + 2]
          ? decodeURIComponent(parts.slice(index + 2).join('/')).split('+').map(handleize).filter(Boolean)
          : [])
    };
  }

  function v576NormalizeIndexPayload(payload, collection) {
    if (collection !== 'all' || !payload || !Array.isArray(payload.items)) return payload;
    var products = Object.create(null);
    var ids = [];
    payload.items.forEach(function (row) {
      if (!Array.isArray(row) || row.length < 10) return;
      var sku = clean(row[0] || '');
      if (!sku) return;
      var cents = Number(row[3] || 0) || 0;
      products[sku] = {
        sku: sku,
        title: clean(row[1] || ''),
        url: clean(row[2] || ''),
        price: (cents / 100).toFixed(2),
        display_type: clean(row[4] || ''),
        image: clean(row[6] || ''),
        available: row[9] !== false,
        compatible_collections: ['all'],
        canonical_part_filters: []
      };
      ids.push(sku);
    });
    return {
      version: 'V647-DATA42-STOCK-1',
      generated_at: '2026-09-17T19:02:00-07:00',
      source: payload.source || 'product_templateMasterIntegy_091626_v42.xlsx',
      schema: 3,
      labels: {}, aliases: {}, collection_aliases: {}, query: {},
      products: products,
      collections: {
        all: {
          buckets: {}, counts: {}, available_handles: [], hidden_filters: {},
          products: ids,
          profile: { profile: 'all-products-stock', heading: 'Refine Results', helper: 'V576 stock candidate owner; Shopify live product JSON is authoritative.' }
        }
      },
      stats: { indexed_products: ids.length, source_schema: payload.schema || null }
    };
  }

  function healFacetMetadata(index) {
    if (!index || !index.collections) return index;
    Object.keys(index.collections).forEach(function (key) {
      var data = index.collections[key] || {};
      var buckets = data.buckets || {};
      var counts = {};
      var available = [];
      Object.keys(buckets).forEach(function (handle) {
        var values = Array.isArray(buckets[handle]) ? buckets[handle] : [];
        if (!values.length) return;
        counts[handle] = values.length;
        available.push(handle);
      });
      data.counts = counts;
      data.available_handles = available;
      data.v571FacetMetadataHealed = true;
    });
    index.v571FacetMetadataHealed = true;
    return index;
  }

  function getIndex() {
    if (!indexPromise) {
      var current = pathData();
      var scopedUrls = window.INTEGY_V454_FILTER_INDEX_URLS || {};
      /* INTEGY V660 — /collections/all previously downloaded the complete search catalog
         (~16.7 MB raw) even though V577 only consumes seven fields for stock rendering.
         Use the compact mirror only for this stock owner; search keeps the full catalog. */
      var v660AllStockUrl = current.collection === 'all' ? (window.INTEGY_V660_ALL_STOCK_INDEX_URL || '') : '';
      var url = v660AllStockUrl || scopedUrls[current.collection] || window.INTEGY_V309_CANONICAL_FILTER_INDEX_URL || window.INTEGY_V307_CANONICAL_INDEX_REBUILD_URL || '';
      if (v660AllStockUrl) root.classList.add('integy-v660-all-compact-index');
      else if (scopedUrls[current.collection]) root.classList.add('integy-v454-scoped-index');
      indexPromise = fetch(url, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('V454 collection filter index unavailable');
          return response.json().then(function (payload) {
            return healFacetMetadata(v576NormalizeIndexPayload(payload, current.collection));
          });
        })
        .catch(function () { return null; });
    }
    return indexPromise;
  }

  function canonical(index, handle) {
    handle = handleize(handle);
    if (!index) return handle;
    if (index.labels && index.labels[handle]) return handle;
    return index.aliases && index.aliases[handle] ? index.aliases[handle] : handle;
  }

  function collectionData(index, handle) {
    if (!index || !handle) return null;
    var key = index.collections && index.collections[handle] ? handle : '';
    if (!key && index.collection_aliases && index.collection_aliases[handle] && index.collections[index.collection_aliases[handle]]) {
      key = index.collection_aliases[handle];
    }
    return key ? { key: key, data: index.collections[key] } : null;
  }

  function unique(values) {
    var seen = Object.create(null);
    var output = [];
    (values || []).forEach(function (value) {
      value = handleize(value);
      if (value && !seen[value]) {
        seen[value] = true;
        output.push(value);
      }
    });
    return output;
  }

  function canonicalTags(index, tags) {
    return unique((tags || []).map(function (tag) { return canonical(index, tag); }));
  }

  function reducedTags(index, tags) {
    var output = canonicalTags(index, tags);
    var parents = index && index.query && index.query.parents ? index.query.parents : {};
    Object.keys(parents).forEach(function (parent) {
      if (output.indexOf(parent) < 0) return;
      var hasChild = (parents[parent] || []).some(function (child) {
        return output.indexOf(child) >= 0;
      });
      if (hasChild) output = output.filter(function (tag) { return tag !== parent; });
    });
    return output;
  }

  function productPath(value) {
    try {
      var url = new URL(value, location.origin);
      var match = url.pathname.match(/\/products\/([^/?#]+)/i);
      return match ? v626LocalizedPath('products/' + match[1].toLowerCase()) : '';
    } catch (error) {
      return '';
    }
  }

  function resolveRecord(index, value) {
    if (!value) return null;
    if (typeof value === 'string') {
      return index && index.products ? index.products[value] : null;
    }
    return value;
  }

  function productSet(index, records) {
    var map = Object.create(null);
    (records || []).forEach(function (value) {
      var record = resolveRecord(index, value);
      if (!record) return;
      var key = productPath(record.url || '');
      if (key) map[key] = record;
    });
    return map;
  }


  /* INTEGY V398 business sanity filter: the canonical index still contains some old broad
     TYPE/TAGS cross-contamination. Keep the filter UI/data, but remove obvious wrong products
     from the rendered filtered collections. */
  function recordTitle(record) {
    return clean((record && (record.title || record.name || record.product_title)) || '');
  }

  function recordType(record) {
    /* INTEGY V610 — prefer the normalized display_type plus any native type/tags.
       Do NOT fold the healed V42 TYPE/TAGS strings back into strict matching: those
       strings can contain inherited collection aliases (the original source of the
       RC Electronics Gyro/Servo contamination). */
    if (!record) return '';
    return clean([
      record.type,
      record.product_type,
      record.display_type,
      record.tags,
      record.product_tags
    ].filter(Boolean).join(' '));
  }

  function recordCollectionHas(record, label) {
    var raw = clean((record && (record.v594_v41_collections || record.v568_v40_collections)) || '');
    if (!raw) return false;
    return raw.split(',').some(function (value) { return clean(value).toLowerCase() === String(label || '').toLowerCase(); });
  }

  function hasActiveTag(tags, value) {
    return (tags || []).indexOf(value) !== -1;
  }


  /* INTEGY V693 — primary-object precedence for RC Electronics.
     A bumper/trailer/body/complete vehicle does not become an electronic product
     merely because it includes LED lights, a radio, ESC, servo, motor, etc. */
  function v693TitleHead(record) {
    var title = clean(record && record.title).toLowerCase();
    return clean((title.split(/\s+(?:w\/|with|compatible\s+with|for)\s+/i)[0] || title));
  }

  function v693PrimaryHostKind(record) {
    var title = clean(record && record.title).toLowerCase();
    var head = v693TitleHead(record);
    if (/\btrailer\b/.test(head) && !/\btrailer\s+(?:hitch|receiver|coupler|ball|hook|axle\s+cover|light|lights|wire|wires|connector|plug|parts?)\b/.test(head)) return 'trailer';
    if (/\bbumper\b/.test(head)) return 'bumper';
    if (!/\bbody\s+(?:mount|post|clip|reamer|washer|screw|hardware)\b/.test(head) && /\b(?:rc\s+body|car\s+body|truck\s+body|body\s+shell|body\s+kit|hard\s+plastic\s+body)\b/.test(head)) return 'body';
    if (/\b(?:rtr|artr|ready[- ]to[- ]run|ready to run)\b/.test(head) && /\b(?:rc\s+car|rc\s+truck|drift\s+car|drift\s+truck|crawler|buggy|truggy|monster\s+truck|short\s+course\s+truck|pickup|tank|boat|hovercraft)\b/.test(head)) return 'vehicle';
    if (/\bcustom\s+built\b/.test(head) && /\b(?:car|truck|crawler|buggy|truggy|vehicle)\b/.test(head)) return 'vehicle';
    return '';
  }

  function v693NegatedLed(record) {
    return /\b(?:without|w\/o|no)\s+(?:led|leds|led\s+lights?|lights?)\b/i.test(clean(record && record.title));
  }

  function v693NegatedMotor(record) {
    return /\b(?:without|w\/o|no)\s+(?:an?\s+)?motors?\b/i.test(clean(record && record.title));
  }

  function v693MechanicalConnector(record) {
    var title = clean(record && record.title);
    return /\b(?:shaft|linkage(?:\s+rod)?|tie\s*rod|steering\s+rod|suspension\s+link|chassis\s+brace)\s+connector\b/i.test(title);
  }

  function v694ResolvedPrimaryType(record) {
    try {
      if (window.IntegyV550Type && typeof window.IntegyV550Type.resolve === 'function') {
        return clean(window.IntegyV550Type.resolve(record && record.title, record && record.display_type || recordType(record))).toLowerCase();
      }
    } catch (error) {}
    return '';
  }

  function v694ActualWheelRecord(record) {
    /* Strict by design: the historical Wheel tag is very noisy. Only the shared
       primary-object resolver may admit a product to the generic Wheel filter. */
    var kind = v694ResolvedPrimaryType(record);
    return kind === 'wheel' || kind === 'wheel & tire set';
  }

  function v694WheelHexRecord(record) {
    var kind = v694ResolvedPrimaryType(record);
    if (kind === 'wheel hex / hub adapter') return true;
    var title = recordTitle(record);
    var raw = recordType(record);
    if (/\breplacement\s+(?:front\s+|rear\s+)?wheels?\b/i.test(title) && /\b(?:w\/o|without|no)\s+(?:wheel\s+)?(?:hub|hex|adapter|adaptor|mount)\b/i.test(title)) return false;
    if (/^wheel\s+hex\b/i.test(raw)) return true;
    return /\b(?:17mm|23mm|24mm|12mm|14mm)\s+hex\s+hub\b|\bwheel(?:\s*\(\d+\))?\s+(?:hex|hub|adapters?|adaptors?)\b|\b(?:hex|hub)\s+wheel(?:\s*\(\d+\))?\s*(?:hub|adapter|adaptor)?\b|\b(?:wheel\s+)?hub\s+adapters?\b/i.test(title);
  }

  function v694WheelNutRecord(record) {
    var kind = v694ResolvedPrimaryType(record);
    if (kind === 'wheel nut') return true;
    if (kind === 'wheel nut wrench') return false;
    var title = recordTitle(record);
    return /\bwheel\s+nuts?\b/i.test(title) && !/\b(?:wrench|driver|socket|tool)\b/i.test(title);
  }

  function v694ActualTireRecord(record) {
    /* The historical Tire tag is also noisy. Keep actual tires and wheel/tire sets;
       reject tools, inserts, mounts, covers, racks, straps and other accessories. */
    var kind = v694ResolvedPrimaryType(record);
    return kind === 'tire' || kind === 'wheel & tire set';
  }

  function v696PrimaryType(record) {
    return v694ResolvedPrimaryType(record);
  }

  function v696ActualReceiverRecord(record) {
    var title = recordTitle(record);
    var lower = title.toLowerCase();
    var kind = v696PrimaryType(record);
    /* Same word, different object: receiver boxes, towing receivers, LED boards,
       winches, harnesses and adapters are not radio receivers. */
    if (/\b(?:hitch|towing|tow)\b[^.]{0,45}\breceiver\b|\breceiver\b[^.]{0,45}\b(?:hitch|towing|tow)\b/i.test(title)) return false;
    if (/\breceiver\s*(?:\/|&|-)?\s*(?:box|case|cover|mount|tray|holder|plate|bracket|housing|guard|enclosure)\b/i.test(title)) return false;
    if (/\b(?:box|case|cover|mount|tray|holder|plate|bracket|housing|guard|enclosure)\b[^.]{0,45}\breceiver\b/i.test(title)) return false;
    if (/\b(?:led|light)\b[^.]{0,80}\b(?:controller|control)\s*(?:board)?\b[^.]{0,80}\breceiver\b|\breceiver\b[^.]{0,80}\b(?:led|light|controller|control\s*board)\b/i.test(title)) return false;
    if (/\b(?:wire|wires|harness|plug|connector|extension|cable|lead|adapter|adaptor|conversion)\b[^.]{0,70}\breceiver\b|\breceiver\b[^.]{0,70}\b(?:wire|wires|harness|plug|connector|extension|cable|lead|adapter|adaptor|conversion)\b/i.test(title)) return false;
    if (/\bwinch\b/i.test(title) && /\breceiver\b/i.test(title)) return false;
    if (/\b(?:wireless\s+video|video)\s+receiver\b|\b5\.?8g\b[^.]{0,30}\breceiver\b/i.test(title)) return false;
    if (/\btransmitters?\b/i.test(title) && !/^\s*receiver\b/i.test(title)) return false;
    if (kind === 'receiver box' || kind === 'receiver mount' || kind === 'trailer hitch / coupler') return false;
    return /\breceiver\b/i.test(lower + ' ' + recordType(record));
  }

  function v696ActualEscRecord(record) {
    var title = recordTitle(record);
    var lower = title.toLowerCase();
    var kind = v696PrimaryType(record);
    if (kind && kind !== 'esc' && kind !== 'motor & esc combo') return false;
    if (/\b(?:esc|electronic\s+speed\s+control(?:ler)?)\b/i.test(title)) {
      if (/\b(?:mount|mounting|post|posts|plate|tray|holder|bracket|case|cover|guard|rail|program(?:mer)?|program\s+card|setup\s+card|capacitor|connector|plug|wire|wires|harness|usb\s+adapter|pc\s+adapter|power\s+switch|switch|cooling\s+fan)\b/i.test(lower) &&
          !/\b(?:electronic\s+speed\s+control(?:ler)?|\d{2,4}a\s+(?:brushless|brushed)?\s*esc|(?:brushless|brushed|sensored|sensorless|marine)\s+esc)\b/i.test(lower)) return false;
      if (/\b(?:mount|rail)\b/i.test(lower) && /\b(?:motor|servo|stuffing\s+tube)\b/i.test(lower)) return false;
      if (/\b(?:for|to)\s+(?:the\s+)?esc\b/i.test(lower) && !/\b(?:electronic\s+speed\s+control(?:ler)?|\d{2,4}a\b)\b/i.test(lower)) return false;
    }
    return kind === 'esc' || /\belectronic\s+speed\s+control(?:ler)?\b/i.test(lower) || /\b(?:brushless|brushed|sensored|sensorless|marine)\s+esc\b/i.test(lower) || /\b\d{2,4}a\b[^.]{0,40}\besc\b/i.test(lower);
  }

  function v696ActualServoRecord(record) {
    var title = recordTitle(record);
    var lower = title.toLowerCase();
    var kind = v696PrimaryType(record);
    if (/\b(?:conversion|upgrade)\s+kit\b|\bcomplete\b[^.]{0,35}\bkit\b|\bgearbox\b|\btransfer\s+case\b|\broll\s+cage\b/i.test(lower)) return false;
    if (/\bservo\b[^.]{0,50}\b(?:motor|esc)\b|\b(?:motor|esc)\b[^.]{0,50}\bservo\b/i.test(lower)) return false;
    if (/\bservo\s+(?:horn|arm|saver|mount|bracket|adapter|extension|lead|wire|cable|tester|programmer|case|gear|gears|plate|guard|link|stay)\b/i.test(lower)) return false;
    if (kind && /^(?:servo horn|servo saver|servo arm|servo mount)$/.test(kind)) return false;
    return /\bservo\b/i.test(lower + ' ' + recordType(record));
  }

  function v696ActualCoolingFanRecord(record) {
    var title = recordTitle(record);
    var kind = v696PrimaryType(record);
    /* A motor/ESC mount that happens to include a fan remains a mount. Actual fan
       and heatsink+fan cooling assemblies remain valid cooling products. */
    if (kind === 'motor mount' || kind === 'esc mount / plate' || kind === 'cooling fan mount' || kind === 'cooling fan cover / guard') return false;
    if (/\bmotor\s+mount\b[^.]{0,80}\b(?:fan|cooling)\b/i.test(title) || /\besc\s+(?:mount|plate|holder|tray|bracket)\b[^.]{0,80}\b(?:fan|cooling)\b/i.test(title)) return false;
    return /\b(?:cooling\s+fan|fan|blower)\b/i.test(title + ' ' + recordType(record));
  }

  function v696ActualLedRecord(record) {
    var title = recordTitle(record);
    var kind = v696PrimaryType(record);
    if (v693NegatedLed(record) || v693PrimaryHostKind(record)) return false;
    if (/\bluggage\s+tray\b/i.test(title)) return false;
    if (/\b(?:fog\s+(?:lamp|light)|headlight|tail\s*light)\b[^.]{0,55}\b(?:trim|cover|eyebrow|protector|bezel|garnish)\b/i.test(title)) return false;
    if (/\b(?:trim|cover|eyebrow|protector|bezel|garnish)\b[^.]{0,55}\b(?:fog\s+(?:lamp|light)|headlight|tail\s*light)\b/i.test(title)) return false;
    if (kind === 'rc body' || kind === 'bumper' || kind === 'trailer') return false;
    return /\b(?:led|light|lights|lamp|lightbar|light\s+bar|headlight|tail\s*light|spotlight)\b/i.test(title + ' ' + recordType(record));
  }

  function v693ElectronicsFeatureFilterActive(tags) {
    var handles = ['servo-horn','servo','connector','gyro','cooling-fan','led-light','receiver','esc','motor','radio-controller','battery-meter','discharger','charger-accessory','power-supply'];
    return handles.some(function (handle) { return hasActiveTag(tags, handle); });
  }

  function strictBusinessRecordAllowed(collection, tags, record) {
    var title = recordTitle(record);
    var hay = (title + ' ' + recordType(record)).toLowerCase();
    var lowerTitle = title.toLowerCase();
    var rejectUnrelated = /\b(?:servo|servo arm|wheel|tire|bumper|linkage|plate|conversion set)\b/i;


    /* INTEGY V694 — generic Wheel must mean an actual wheel, not a tool,
       hub/hex, axle, nut, spacer, weight, beadlock ring, steering wheel, or wheelie bar. */
    if (hasActiveTag(tags, 'wheel')) return v694ActualWheelRecord(record);
    if (hasActiveTag(tags, 'wheel-hex')) return v694WheelHexRecord(record);
    if (hasActiveTag(tags, 'wheel-nut')) return v694WheelNutRecord(record);
    if (hasActiveTag(tags, 'tire')) return v694ActualTireRecord(record);

    if (collection === 'rc-electronics') {
      /* V693: primary host beats included-feature tags. */
      if (v693ElectronicsFeatureFilterActive(tags) && v693PrimaryHostKind(record)) return false;
      if (hasActiveTag(tags, 'led-light') && v693NegatedLed(record)) return false;
      if (hasActiveTag(tags, 'motor') && v693NegatedMotor(record)) return false;
      if (hasActiveTag(tags, 'receiver') && /\b(?:trailer\s+hitch\s+receiver|hitch\s+receiver|receiver\s+hook)\b/i.test(title)) return false;
      if (hasActiveTag(tags, 'connector') && v693MechanicalConnector(record)) return false;
    }

    /* V498 high-risk legacy filters: keep their result sets semantically honest
       even when a shopper follows an old bookmarked URL. */
    if (hasActiveTag(tags, '2-2-3-0-short-course')) {
      return /\b(?:tire|tires|wheel|wheels|premounted|pre-mounted|beadlock|foam insert)\b/i.test(title + ' ' + recordType(record));
    }
    if (hasActiveTag(tags, 'axial-4x4-rbx10-ryft-rock-bouncer') || hasActiveTag(tags, 'for-axial-rbx10-ryft') || hasActiveTag(tags, 'rbx10-ryft') || hasActiveTag(tags, 'ryft')) {
      return /\b(?:rbx10|ryft)\b/i.test(title + ' ' + recordType(record));
    }
    if (hasActiveTag(tags, '1st-and-2nd-generation-rs4') || hasActiveTag(tags, 'hpi-1st-and-2nd-generation-rs4')) {
      return /\brs4\b/i.test(title + ' ' + recordType(record));
    }
    if (hasActiveTag(tags, '3racing-bead-lock-ring-cr-01')) {
      return /\b(?:bead\s*lock|beadlock)\b/i.test(title + ' ' + recordType(record)) && /\bcr-?01\b/i.test(title + ' ' + recordType(record));
    }

    if (collection === 'rc-tools' && hasActiveTag(tags, 'body-reamer')) {
      if (/\breamer\b/i.test(title)) return true;
      return false;
    }

    if (collection === 'rc-tools' && hasActiveTag(tags, 'cutting-tool')) {
      if (/\b(?:stand|workstation|setup station|setup board|organizer|display ramp|adapter)\b/i.test(title)) return false;
      return /\b(?:cutter|cutting|scissor|scissors|knife|file|files|plier|pliers|pincer|nipper|side cutter|diagonal)\b/i.test(title);
    }

    if (collection === 'rc-tools' && hasActiveTag(tags, 'tool-bag')) {
      if (/\b(?:resistor|transformer|armature|display ramp|workstation|stand|adapter|wheel nut|wrench tip|hex tool tip|setup station)\b/i.test(title)) return false;
      return /\b(?:bag|case|carry|carrying|pouch)\b/i.test(title);
    }

    if (collection === 'rc-electronics' && hasActiveTag(tags, 'servo-horn')) {
      if (/\b(?:receiver|transmitter|radio|esc|motor|gyro|battery|wire|wires|connector|plug|fan|heatsink|led|light|charger|discharger|power supply|starter box|steering wheel)\b/i.test(title) && !/\bservo\s+(?:horn|arm|saver)\b/i.test(title)) return false;
      return /\bservo\s+(?:horn|arm|saver)\b/i.test(title) || /\b(?:single|double)\s+arm\b/i.test(title) || /\b(?:23t|24t|25t)\b/i.test(title + ' ' + hay);
    }

    /* INTEGY V610 — RC Electronics high-confidence taxonomy guards. The V42
       source contains inherited collection tags, so an active filter must be
       supported by the product title/type evidence rather than by a broad tag
       alone. These guards affect filtered/indexed results only; the native base
       RC Electronics collection remains Shopify-owned. */
    if (collection === 'rc-electronics' && hasActiveTag(tags, 'servo')) {
      return v696ActualServoRecord(record);
    }
    if (collection === 'rc-electronics' && hasActiveTag(tags, 'connector')) {
      if (v693MechanicalConnector(record)) return false;
      return /\b(?:connector|plug|socket|bullet|harness|adapter|adaptor|wire|wires|cable|lead|banana|deans|xt30|xt60|xt90|ec2|ec3|ec5|jst|tamiya plug)\b/i.test(title + ' ' + recordType(record));
    }
    if (collection === 'rc-electronics' && hasActiveTag(tags, 'gyro')) {
      return /\bgyro(?:scope)?\b/i.test(title + ' ' + recordType(record));
    }
    if (collection === 'rc-electronics' && hasActiveTag(tags, 'cooling-fan')) {
      return v696ActualCoolingFanRecord(record);
    }
    if (collection === 'rc-electronics' && hasActiveTag(tags, 'led-light')) {
      return v696ActualLedRecord(record);
    }

    if (hasActiveTag(tags, 'brace')) {
      if (rejectUnrelated.test(lowerTitle) && !/\bbrace\s+mount\b/i.test(lowerTitle)) return false;
      return /\b(?:(?:chassis|front|rear|center|centre)\s+)?brace\b/i.test(title) || /\bbrace\b/i.test(recordType(record));
    }
    if (hasActiveTag(tags, 'bumper')) {
      return /\bbumper\b/i.test(title) || /\bbumper\b/i.test(recordType(record));
    }
    if (hasActiveTag(tags, 'receiver')) {
      if (v693PrimaryHostKind(record)) return false;
      return v696ActualReceiverRecord(record);
    }
    if (hasActiveTag(tags, 'esc')) {
      return v696ActualEscRecord(record);
    }
    if (hasActiveTag(tags, 'motor')) {
      if (v693NegatedMotor(record)) return false;
      if (/\bmotor\s+(?:mount|plate|guard|cover|heatsink|heat sink|fan|armature|spring|brush|wire|shaft|adapter|spacer|pinion|gear|case|can|screw|bearing|analyzer|tester|tool|connector|plug)\b/i.test(title)) return false;
      if (/\b(?:armatures?|springs?|brushes|lathe|cooling|fans?|heatsinks?|heat sinks?|battery case|motor can|endbell|rotor|stator|commutator|motor tools?|motor testers?|motor analyzers?)\b/i.test(title)) return false;
      if (/\b(?:mounts?|mounting|adapters?|posts?|plugs?|connectors?|wires?|pinions?|gears?|screws?|bearings?)\b/i.test(title)) return false;
      if ((/\besc\b/i.test(title) && /\bmotor\b/i.test(title)) || /\bmotor\s*(?:\+|and|&)\s*esc\b/i.test(title)) return false;
      return /\bmotor\b/i.test(title) || /\bmotor\b/i.test(recordType(record));
    }
    if (hasActiveTag(tags, 'turnbuckle')) {
      return /\bturnbuckle(?:s)?\b/i.test(title) || /\bturnbuckle\b/i.test(recordType(record));
    }
    if (hasActiveTag(tags, 'tie-rod')) {
      return /\btie[\s-]?rod(?:s)?\b/i.test(title) || /\btie[\s-]?rod\b/i.test(recordType(record));
    }
    if (hasActiveTag(tags, 'rod-end')) {
      return /\brod[\s-]?end(?:s)?\b/i.test(title) || /\brod[\s-]?end\b/i.test(recordType(record));
    }
    if (hasActiveTag(tags, 'suspension-link')) {
      return /\b(?:suspension|trailing|upper|lower)\s+link(?:s)?\b/i.test(title) || /\bsuspension[\s-]?link\b/i.test(recordType(record));
    }
    if (hasActiveTag(tags, 'suspension-arm')) {
      return !/\bservo\s+arm\b/i.test(title) && (/\bsuspension\s+arm(?:s)?\b/i.test(title) || /\b(?:front|rear|upper|lower)\s+(?:a[- ]?)?arm(?:s)?\b/i.test(title) || /\bsuspension[\s-]?arm\b/i.test(recordType(record)));
    }
    if (hasActiveTag(tags, 'skid-plate')) return /\bskid[\s-]?plate(?:s)?\b/i.test(title + ' ' + recordType(record));
    if (hasActiveTag(tags, 'chassis-plate')) return /\bchassis[\s-]?plate(?:s)?\b/i.test(title + ' ' + recordType(record));
    if (hasActiveTag(tags, 'ball-link')) return /\bball[\s-]?link(?:s)?\b/i.test(title + ' ' + recordType(record));
    if (hasActiveTag(tags, 'shock-shaft')) return /\bshock[\s-]?shaft(?:s)?\b/i.test(title + ' ' + recordType(record));
    if (hasActiveTag(tags, 'bearing')) return /\bbearing(?:s)?\b/i.test(title + ' ' + recordType(record));
    if (hasActiveTag(tags, 'body-mount')) return /\bbody[\s-]?(?:mount|post)(?:s)?\b/i.test(title + ' ' + recordType(record));

    return true;
  }

  /* V548 high-confidence scale contract. Bare inherited 1-N tags are not evidence;
     require an explicit ratio, a scale-qualified model handle, or a verified model family. */
  var v548ScalePatterns = {
    '1-4': [/\bpromoto(?:\s*mx)?\b/i],
    '1-5': [/\b5ive[-\s]?t\b/i,/\bdbxl(?:-e)?\b/i,/\bdesert\s+buggy\s+xl(?:-e)?\b/i,/\bkraton\s+8s\b/i,/\boutcast\s+8s\b/i,/\bx-maxx\b/i,/\bxrt\b/i],
    '1-6': [/\bsuper\s+baja\s+rey\b/i],
    '1-7': [/\binfraction\s+6s\b/i,/\bfelony\s+6s\b/i,/\blimitless\b/i,/\bmojave\s+6s\b/i,/\bbig\s+rock\s+6s\b/i,/\bunlimited\s+desert\s+racer\b/i,/\budr\b/i],
    '1-8': [/\bkraton\s+6s\b/i,/\boutcast\s+6s\b/i,/\bnotorious\s+6s\b/i,/\btyphon(?:\s+(?:3s|6s))?\b/i,/\btalion\s+6s\b/i,/\bsledge\s+6s\b/i,/\binfraction\s+3s\b/i,/\bmojave\s+4s\b/i,/\b8ight(?:-t)?\b/i,/\blmt(?:\s+2\.0)?\b/i,/\blst\s*2?\b/i,/\baftershock\b/i,/\bapache\b/i,/\bi8mt\b/i,/\bmaxx\s+slash\b/i],
    '1-10': [/\bslash\b/i,/\bstampede\b/i,/\brustler\b/i,/\bbandit\b/i,/\bhoss\b/i,/\bjato\b/i,/\bsummit\b/i,/\b4[- ]?tec\b/i,/\bbigfoot\b/i,/\btrx[- ]?4\b(?!m)/i,/\btrx[- ]?6\b/i,/\blasernut\b/i,/\bbaja\s+rey\b/i,/\bsenton\b/i,/\bgranite\b/i,/\bvorteks\b/i,/\bkraton\s+4s\b/i,/\boutcast\s+4s\b/i,/\b22s\b/i,/\bten[- ]?t\b/i,/\bten[- ]?scte\b/i,/\bscx10\b/i,/\bwraith\b/i,/\bmaxx\s+(?:4s|v2|widemaxx)\b/i],
    '1-14': [/\bcustom\s+semi\s+truck\b/i],
    '1-16': [/\bmini\s+(?:maxx|xrt|slash)\b/i,/\b1[\/ -]?16\s+e-?revo\b/i,/\bmojave\s+grom\b/i],
    '1-18': [/\btrx[- ]?4m\b/i,/\bmini\s+lmt\b/i,/\bmini[- ]?t(?:\s+2\.0)?\b/i,/\bmini[- ]?lst\b/i,/\blatrax\b/i,/\bmini\s+rock\s+crawler\b/i],
    '1-24': [/\bmicro[- ]?b\b/i], '1-28': [/\bmini[- ]?z\b/i], '1-36': [/\bmicro[- ]?t\b/i,/\bmicro\s+baja\b/i]
  };
  function v548ScaleEvidence(record) {
    /* V549: display_type is deliberately excluded from scale evidence. It can
       contain inherited broad TYPE text (the source of many false 1/8 tags). */
    var evidence = Object.create(null);
    var explicit = Object.create(null);
    var title = clean((record && record.title) || '');
    var urlText = clean((record && record.url) || '')
      .replace(/pinion-and-spur-gears-for-1-5-1-8-1-10-1-12-1-18-rc/ig, ' ');
    var titleUrl = title + ' ' + urlText;
    var filters = (record && record.canonical_part_filters || []);
    var modelText = titleUrl + ' ' + filters.filter(function (h) { return !/^1-\d{1,2}$/.test(h); }).join(' ');
    /* V636: explicit scale ratios come from the product title only. The legacy
       Pinion & Spur collection handle itself contains 1-5/1-8/1-10/1-12/1-18,
       so parsing ratios from record.url falsely marked every generic gear as
       compatible with all five scales. URL/model text is still useful for
       named-vehicle evidence after that broad handle is stripped. */
    var ratio = /(?:^|\D)1\s*[\/:]\s*(4|5|6|7|8|10|12|14|16|18|24|28|36)(?!\d)/ig, match;
    while ((match = ratio.exec(title))) { evidence['1-' + match[1]] = true; explicit['1-' + match[1]] = true; }
    filters.forEach(function (handle) {
      var m = String(handle || '').match(/^1-(4|5|6|7|8|10|12|14|16|18|24|28|36)-.+/);
      if (m) { evidence['1-' + m[1]] = true; explicit['1-' + m[1]] = true; }
    });
    Object.keys(v548ScalePatterns).forEach(function (scale) {
      if (v548ScalePatterns[scale].some(function (pattern) { return pattern.test(modelText); })) evidence[scale] = true;
    });
    if (/\bmini\s+(?:maxx|xrt|slash)\b/i.test(modelText)) evidence['1-16'] = true;
    if (/\bmini\s+xrt\b/i.test(modelText) && !explicit['1-5']) evidence['1-5'] = false;
    if (/\bmini\s+lmt\b/i.test(modelText) || /\bmini[- ]?lst\b/i.test(modelText)) { evidence['1-18'] = true; if (!explicit['1-8']) evidence['1-8'] = false; }
    if (/\bsuper\s+baja\s+rey\b/i.test(modelText)) { evidence['1-6'] = true; if (!explicit['1-10']) evidence['1-10'] = false; }
    if (/\bmaxx\s+slash\b/i.test(modelText)) evidence['1-8'] = true;
    if (/\bx-maxx\b/i.test(modelText)) evidence['1-5'] = true;
    if (/\bmini\s+maxx\b/i.test(modelText) && !explicit['1-10'] && !/\bmaxx\s+(?:4s|v2|widemaxx)\b/i.test(modelText.replace(/\bmini\s+maxx\b/ig,''))) evidence['1-10'] = false;
    if (/\bmini\s+slash\b/i.test(modelText) && !explicit['1-10']) {
      var nonMiniSlash = modelText.replace(/\bmini\s+slash(?:\s+4x4)?\b/ig,'').replace(/\bmaxx\s+slash\b/ig,'');
      if (!/\bslash(?:\s+(?:2wd|4x4|vxl|bl-2s|ultimate|short course))?\b/i.test(nonMiniSlash)) evidence['1-10'] = false;
    }
    Object.keys(evidence).forEach(function (key) { if (!evidence[key]) delete evidence[key]; });
    return evidence;
  }
  /* V551 brand-aware Traxxas scale contract. Scale means the scale of the
     compatible Traxxas vehicle, not a measurement or another brand's vehicle. */
  var v551TraxxasAllowedScales = {'1-5':1,'1-6':1,'1-7':1,'1-8':1,'1-10':1,'1-16':1,'1-18':1};
  function v551TraxxasCollection(collection) {
    return /^(?:hop-up-parts-for-traxxas|hopups-for-traxxas|parts-for-traxxas|traxxas|hop-up-parts-for-traxxas-mini-xrt|hop-up-parts-for-traxxas-mini-slash-4x4)$/.test(String(collection || ''));
  }
  function v551TraxxasScaleEvidence(record) {
    var ev = Object.create(null);
    var title = clean((record && record.title) || '').toLowerCase();
    var handles = (record && record.canonical_part_filters || []).map(function(h){return clean(h).toLowerCase();}).filter(function(h){return !/^1-\d{1,2}$/.test(h);});
    var text = title + ' ' + handles.join(' ');
    var test = function(re, value){ if (re.test(value == null ? text : value)) return true; return false; };
    if (test(/\bx[- ]?maxx\b|\bpro[- ]?scale[- ]?sand[- ]?car\b|\bx[- ]?monster[- ]?chassis\b/)) ev['1-5']=true;
    var titleNoMiniXrt = title.replace(/\bmini[- ]?xrt\b/g,' ');
    var explicitFullXrt = /\bxrt(?:[- ]?8s)?\b/.test(titleNoMiniXrt) || handles.some(function(h){return /\bxrt[- ]?8s\b|\btraxxas[- ]?xrt\b/.test(h);});
    if (explicitFullXrt) ev['1-6']=true;
    if (test(/\bunlimited[- ]?desert[- ]?racer\b|(?:^|[\s-])udr(?:$|[\s-])/)) ev['1-7']=true;
    if (test(/\bjato[- ]?4x4\b|\bmaxx[- ]?slash(?:[- ]?6s)?\b|\bsledge(?:[- ]?(?:4wd|6s))?\b/)) ev['1-8']=true;
    if (test(/\bmini[- ]?(?:maxx|xrt|slash)(?:[- ]?4x4)?\b/)) ev['1-16']=true;
    if (/\b1\s*[\/:]\s*16\b/.test(title) && /\b(?:e-?revo|slash|summit|rally|traxxas)\b/.test(text)) ev['1-16']=true;
    if (test(/\btrx[- ]?4m\b|\blatrax\b/)) ev['1-18']=true;
    var u=text;
    [/\bx[- ]?maxx\b/g,/\bmini[- ]?maxx\b/g,/\bmini[- ]?xrt\b/g,/\bmini[- ]?slash(?:[- ]?4x4)?\b/g,/\bmaxx[- ]?slash(?:[- ]?6s)?\b/g,/\btrx[- ]?4m\b/g,/\bjato[- ]?4x4\b/g].forEach(function(re){u=u.replace(re,' ');});
    if (/\bmaxx[- ]?(?:4s|v2|v2[- ]?with[- ]?widemaxx)\b|\bwidemaxx\b/.test(u)) ev['1-10']=true;
    var explicit16=!!ev['1-16'];
    if (/\bbandit\b|\bbigfoot\b|\bdrag[- ]?slash\b|\bt[- ]?maxx\b|\be[- ]?maxx\b|\bhoss\b|\bmonster[- ]?jam\b|\bnitro[- ]?rustler\b|\bnitro[- ]?slash\b|\brustler\b|\bstampede\b|\btelluride\b|\btrx[- ]?4\b|\btrx[- ]?6\b|\b4[- ]?tec\b/.test(u)) ev['1-10']=true;
    if (!explicit16 && /\be[- ]?revo\b|\brevo\b|\bslayer\b|\bsummit\b|\bslash\b|\b(?:st[- ]?)?rally\b/.test(u)) ev['1-10']=true;
    if (/\bjato(?:[- ]?(?:2\.5|3\.3))?\b/.test(u)) ev['1-10']=true;
    /* Brand-qualified explicit ratios only; no 1/4-inch, 14T, 16T, bore or drive inference. */
    var m, br=/\btraxxas\b[^|,;]{0,24}?\b1\s*[\/:]\s*(5|6|7|8|10|16|18)\b/g;
    while((m=br.exec(title))) ev['1-'+m[1]]=true;
    Object.keys(ev).forEach(function(k){if(!v551TraxxasAllowedScales[k]) delete ev[k];});
    return ev;
  }
  function v552AllIntegyCollection(collection) {
    return /^(?:all-integy-hop-up-parts|all-integy-parts|all-hop-up-parts|all-hopups)$/.test(String(collection || ''));
  }
  function v552GlobalScaleRecordAllowed(record, scale) {
    var declared = record && record.v552_scales;
    if (Array.isArray(declared)) return declared.indexOf(scale) >= 0;
    return !!v548ScaleEvidence(record)[scale];
  }
  function v548ScaleRecordAllowed(tags, record, collection) {
    var scale = (tags || []).find(function (tag) { return /^1-\d{1,2}$/.test(tag); });
    if (!scale) return true;
    if (v551TraxxasCollection(collection)) return !!v551TraxxasScaleEvidence(record)[scale];
    if (v552AllIntegyCollection(collection)) return v552GlobalScaleRecordAllowed(record, scale);
    return !!v548ScaleEvidence(record)[scale];
  }

  function applyStrictBusinessFilter(collection, tags, records) {
    if (!records || !records.length || !tags || !tags.length) return records || [];
    var strictHandles = ['brace', 'bumper', 'servo-horn', 'servo', 'connector', 'gyro', 'cooling-fan', 'led-light', 'receiver', 'esc', 'motor', 'wheel', 'wheel-hex', 'wheel-nut', 'tire', 'turnbuckle', 'tie-rod', 'rod-end', 'suspension-link', 'suspension-arm', 'skid-plate', 'chassis-plate', 'ball-link', 'shock-shaft', 'bearing', 'body-mount', '2-2-3-0-short-course', 'axial-4x4-rbx10-ryft-rock-bouncer', 'for-axial-rbx10-ryft', 'rbx10-ryft', 'ryft', '1st-and-2nd-generation-rs4', 'hpi-1st-and-2nd-generation-rs4', '3racing-bead-lock-ring-cr-01'];
    var scaleStrict = (tags || []).some(function (handle) { return /^1-\d{1,2}$/.test(handle); });
    var needsStrict = scaleStrict || (collection === 'rc-tools' && (hasActiveTag(tags, 'body-reamer') || hasActiveTag(tags, 'cutting-tool') || hasActiveTag(tags, 'tool-bag'))) ||
      strictHandles.some(function (handle) { return hasActiveTag(tags, handle); });
    if (!needsStrict) return records;
    return records.filter(function(record){ return v548ScaleRecordAllowed(tags, record, collection) && strictBusinessRecordAllowed(collection, tags, record); });
  }

  function requestedStockMode() {
    try {
      var params = new URLSearchParams(location.search || '');
      var nativeAvailability = params.get('filter.v.availability') || '';
      var customAvailability = params.get('integy_stock') || '';
      if (nativeAvailability === '0' || customAvailability === 'out') return 'out';
      if (customAvailability === 'all') return 'all';
      return 'in';
    } catch (error) {
      return 'in';
    }
  }

  function recordIsAvailable(record) {
    return !record || record.available !== false;
  }

  /* V565/V549: cached index availability is never allowed to exclude a candidate.
     It is only a stable ordering hint so Out of Stock pages reach likely sold-out
     products first while Shopify product JSON remains the customer-facing truth. */
  function availabilityRecords(records) {
    var mode = requestedStockMode();
    records = (records || []).slice();
    if (mode === 'all') return records;
    return records.map(function (record, index) {
      var cached = recordIsAvailable(record);
      var preferred = mode === 'out' ? !cached : cached;
      return { record: record, index: index, preferred: preferred ? 0 : 1 };
    }).sort(function (a, b) { return a.preferred - b.preferred || a.index - b.index; })
      .map(function (entry) { return entry.record; });
  }

  /* V576: collapse duplicate indexed identities before pagination. */
  function dedupeIndexedRecords(records) {
    var seenSku = Object.create(null);
    var seenPath = Object.create(null);
    var output = [];
    (records || []).forEach(function (record) {
      if (!record) return;
      var sku = clean(record.sku || '').toUpperCase();
      var path = productPath(record.url || '');
      if ((sku && seenSku[sku]) || (path && seenPath[path])) return;
      if (sku) seenSku[sku] = true;
      if (path) seenPath[path] = true;
      output.push(record);
    });
    return output;
  }

  function v576RecordIdentity(record) {
    if (!record) return '';
    var sku = clean(record.sku || '').toUpperCase();
    var path = productPath(record.url || '');
    return sku ? 'sku:' + sku : (path ? 'path:' + path : '');
  }

  /* V576: audited collections with material index-vs-live membership drift. */
  var v576MembershipRiskCollections = {
    'all': true,
    'all-integy-hop-up-parts': true,
    // V656: these individual model collections now use Shopify as the source of truth.
    // Never rescue an empty/native page from stale V42 membership.
    'hop-up-parts-for-losi-1-18-mini-lmt-4x4-brushed-monster-truck-rtr': true,
    'hop-up-parts-for-losi-1-18-mini-lmt-4x4-brushed-monster-truck': true,
    'hop-up-parts-for-losi-1-18-4x4-mini-lmt-monster-truck': true,
    'hop-up-parts-for-arrma-1-5-kraton-8s-blx': true,
    'hop-up-parts-for-traxxas-1-18-trx-4m-scale-and-trail-crawler': true,
    'hop-up-parts-for-traxxas-trx-4m-crawler': true,
    'hop-up-parts-for-traxxas-1-18-trx-4m-crawler': true,
    'hop-up-parts-for-traxxas': true, 'hopups-for-traxxas': true, 'parts-for-traxxas': true,
    'hop-up-parts-for-hpi-racing': true, 'hopups-for-hpi-racing': true, 'parts-for-hpi-racing': true, 'parts-for-hpi': true,
    'rc-electronics': true,
    'tires-wheels-hex-inserts-for-rc-cars-trucks': true
  };

  function v576IndexedStockSubset(collection, records) {
    var mode = requestedStockMode();
    if (!indexedStockOwnerForCollection(collection) || mode === 'all') return records || [];
    return (records || []).filter(function (record) {
      var available = recordIsAvailable(record);
      return mode === 'out' ? !available : available;
    });
  }

  function recordsFor(index, collection, tags, options) {
    options = options || {};
    var scoped = collectionData(index, collection);
    if (!scoped || !scoped.data) return { records: [], tags: [], displayTags: canonicalTags(index, tags), collection: '' };
    var active = reducedTags(index, tags);
    if (!active.length) {
      var baseRecords = [];
      (scoped.data.products || []).forEach(function (sku) {
        var record = resolveRecord(index, sku);
        if (record) baseRecords.push(record);
      });
      baseRecords = dedupeIndexedRecords(baseRecords);
      if (options.stockSubset !== false) baseRecords = v576IndexedStockSubset(collection, baseRecords);
      return { records: availabilityRecords(baseRecords), tags: active, displayTags: canonicalTags(index, tags), collection: scoped.key };
    }
    var strictFallbackTags = ['brace', 'bumper', 'servo-horn', 'servo', 'connector', 'gyro', 'cooling-fan', 'led-light', 'receiver', 'esc', 'motor', 'turnbuckle', 'tie-rod', 'rod-end', 'suspension-link'];
    var maps = active.map(function (tag) {
      var map = productSet(index, scoped.data.buckets && scoped.data.buckets[tag]);
      if (!Object.keys(map).length && strictFallbackTags.indexOf(tag) !== -1) {
        map = productSet(index, scoped.data.products || []);
      }
      return map;
    });
    if (maps.some(function (map) { return Object.keys(map).length === 0; })) {
      return { records: [], tags: active, displayTags: canonicalTags(index, tags), collection: scoped.key };
    }
    var first = maps[0];
    var records = [];
    Object.keys(first).forEach(function (key) {
      if (maps.every(function (map) { return !!map[key]; })) records.push(first[key]);
    });
    records = applyStrictBusinessFilter(scoped.key, active, records);
    records = dedupeIndexedRecords(records);
    if (options.stockSubset !== false) records = v576IndexedStockSubset(collection, records);
    records = availabilityRecords(records);
    return { records: records, tags: active, displayTags: canonicalTags(index, tags), collection: scoped.key };
  }


  /* V576: cached V42 availability is only a provisional stock hint for facets.
     A stale workbook snapshot must never be the sole reason a valid taxonomy choice
     disappears. If the cached stock subset is non-empty, use it for the initial count;
     if it is empty, keep the full candidate set visible and let the V576 reliability
     layer live-verify small/rare candidate sets against Shopify product JSON. */
  function facetRecordsFor(index, collection, tags) {
    var result = recordsFor(index, collection, tags, { stockSubset: false });
    var mode = requestedStockMode();
    if (mode === 'all') return result;
    var all = (result.records || []).slice();
    var cached = all.filter(function (record) {
      var available = recordIsAvailable(record);
      return mode === 'out' ? !available : available;
    });
    result.stockFacetCandidateCount = all.length;
    result.stockFacetProvisional = true;
    if (cached.length) {
      result.records = cached;
      result.stockFacetCachedCount = cached.length;
    } else {
      // Conservative fallback: do not hide a valid facet only because the indexed snapshot says zero.
      result.records = all;
      result.stockFacetCachedCount = 0;
      result.stockFacetNeedsLiveVerification = all.length > 0;
    }
    return result;
  }

  var exactIndexedSorts = {
    'price-descending': true,
    'price-ascending': true,
    'title-ascending': true,
    'title-descending': true
  };

  function rawSortBy() {
    try {
      var params = new URLSearchParams(location.search || '');
      var fromUrl = params.get('sort_by');
      if (fromUrl) return String(fromUrl);
    } catch (error) {}
    var select = qs('select[name="sort_by"], [data-sort-by] select, select[data-productgrid-trigger-sort]');
    return select && select.value ? String(select.value) : '';
  }

  function indexedOrderingActive() {
    var current = pathData();
    if (!current.collection || !targetCollections[current.collection]) return false;
    if (forcedIndexedMembershipCollections[current.collection]) return true;
    if (current.tags && current.tags.length) return true;
    if (indexedStockOwnerForCollection(current.collection) && requestedStockMode() !== 'all') return true;
    return current.collection === 'all-integy-hop-up-parts';
  }

  function exactIndexedSort(value) {
    value = String(value || '');
    return !!exactIndexedSorts[value];
  }

  function currentSortBy() {
    var value = rawSortBy();
    // V537: Shopify can calculate Featured/manual, Best selling, Most relevant and
    // created-date ordering for a native collection. Once V501 owns a filtered/indexed
    // subset, those black-box ranks are not present in the index. Never pretend that
    // retaining the native page order is an exact catalog-wide sort. Use a deterministic
    // title sort until the shopper returns to All items/native collection ordering.
    if (indexedOrderingActive() && !exactIndexedSort(value)) return 'title-ascending';
    return value;
  }

  function configureIndexedSortUi() {
    if (!indexedOrderingActive()) return;
    var effective = currentSortBy();
    var raw = rawSortBy();
    qsa('select[name="sort_by"], select[data-productgrid-trigger-sort], .utils-sortby-select').forEach(function (select) {
      qsa('option', select).forEach(function (option) {
        if (!exactIndexedSort(option.value)) option.remove();
      });
      if (qsa('option', select).some(function (option) { return option.value === effective; })) select.value = effective;
      select.setAttribute('data-integy-v537-exact-index-sort', 'true');
      // V542: make the restricted indexed sort control self-explanatory instead
      // of relying on the poorly supported aria-description attribute.
      select.setAttribute('data-integy-v542-sort-control', 'true');
      select.setAttribute('aria-label', 'Sort stock-filtered results');
      select.setAttribute('title', 'Stock-filtered results support exact price and alphabetical sorting.');
    });
    qsa('[data-productgrid-sort-content] button[value], .utils-sortby--modal-button[value]').forEach(function (button) {
      if (!exactIndexedSort(button.value)) {
        var item = button.closest('li');
        if (item) item.remove(); else button.remove();
      }
    });
    if (raw !== effective) {
      try {
        var url = new URL(location.href);
        url.searchParams.set('sort_by', effective);
        window.history.replaceState(window.history.state, '', url.pathname + '?' + url.searchParams.toString() + url.hash);
      } catch (error) {}
    }
    root.classList.add('integy-v537-exact-index-sort', 'integy-v542-sort-control-ready');
  }

  function numericPrice(record) {
    var value = clean(record && record.price);
    value = value.replace(/[$,]/g, '');
    var n = Number(value);
    return Number.isFinite(n) ? n : 0;
  }

  function sortedRecords(records, collection, tags) {
    var sort = currentSortBy();
    if (!sort && collection === 'rc-electronics' && hasActiveTag(tags, 'servo-horn')) sort = 'price-descending';
    if (!sort) return records;
    var output = (records || []).slice();
    if (sort === 'price-descending') {
      output.sort(function (a, b) { return numericPrice(b) - numericPrice(a) || clean(a.title).localeCompare(clean(b.title)); });
      return output;
    }
    if (sort === 'price-ascending') {
      output.sort(function (a, b) { return numericPrice(a) - numericPrice(b) || clean(a.title).localeCompare(clean(b.title)); });
      return output;
    }
    if (sort === 'title-ascending') {
      output.sort(function (a, b) { return clean(a.title).localeCompare(clean(b.title)); });
      return output;
    }
    if (sort === 'title-descending') {
      output.sort(function (a, b) { return clean(b.title).localeCompare(clean(a.title)); });
      return output;
    }
    return records;
  }

  function retainedQueryString() {
    try {
      var params = new URLSearchParams(location.search || '');
      ['page', 'view', 'grid_list', 'integy_filter', 'integy_filters', 'integy_tag_filter',
       '_su_rec', '_su_rec_id', '_pos', '_fid', '_ss', 'gclid', 'fbclid',
       'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (key) { params.delete(key); });
      return params.toString();
    } catch (error) {
      return '';
    }
  }

  function appendQuery(url, query) {
    if (!query) return url;
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + query;
  }

  function buildUrl(collection, tags) {
    collection = canonicalCollectionHandle(collection);
    tags = unique(tags || []);
    var extra = retainedQueryString();
    var url = '';
    if (queryFilterCollection(collection)) {
      url = v626LocalizedPath('collections/' + collection) + (tags.length ? '?integy_filter=' + tags.map(encodeURIComponent).join('%2B') : '');
      return appendQuery(url, extra);
    }
    url = v626LocalizedPath('collections/' + collection) + (tags.length ? '/' + tags.map(encodeURIComponent).join('+') : '');
    return appendQuery(url, extra);
  }

  function tagsFromUrl(value) {
    try {
      var url = new URL(value, location.origin);
      var parts = url.pathname.split('/').filter(Boolean);
      var at = parts.indexOf('collections');
      if (at < 0 || !parts[at + 1]) return null;
      var tags = url.searchParams.get('integy_filter');
      tags = tags ? tags.split('+') : (parts[at + 2] ? decodeURIComponent(parts.slice(at + 2).join('/')).split('+') : []);
      return { collection: handleize(parts[at + 1]), tags: tags.map(handleize).filter(Boolean), url: url };
    } catch (error) { return null; }
  }

  function normalizedCollectionUrl(value, index) {
    var parsed = tagsFromUrl(value);
    if (!parsed) return '';
    var normalizedCollection = canonicalCollectionHandle(parsed.collection);
    var normalized = normalizeGroupTags(index || {}, parsed.tags || []);
    var collectionChanged = normalizedCollection !== parsed.collection;
    var tagsChanged = normalized.join('+') !== (parsed.tags || []).join('+');
    var extra = new URLSearchParams(parsed.url.search || '');
    ['integy_filter', 'page'].forEach(function (key) { extra.delete(key); });
    var stockChanged = false;
    if (normalizedCollection === 'hopups-for-traxxas') {
      var nativeStock = extra.get('filter.v.availability') || '';
      if (nativeStock === '1' || nativeStock === '0') {
        extra.delete('filter.v.availability');
        extra.set('integy_stock', nativeStock === '0' ? 'out' : 'in');
        stockChanged = true;
      }
    }
    if (!collectionChanged && !tagsChanged && !stockChanged) return '';
    var path = v626LocalizedPath('collections/' + normalizedCollection) + (queryFilterCollection(normalizedCollection)
      ? (normalized.length ? '?integy_filter=' + normalized.map(encodeURIComponent).join('%2B') : '')
      : (normalized.length ? '/' + normalized.map(encodeURIComponent).join('+') : ''));
    var query = extra.toString();
    return path + (query ? (path.indexOf('?') >= 0 ? '&' : '?') + query : '');
  }

  function repairCurrentUrl(index) {
    var repaired = normalizedCollectionUrl(location.href, index || {});
    if (!repaired) return false;
    root.classList.add('integy-v426-filter-url-repair');
    location.replace(repaired);
    return true;
  }

  function repairFilterLinks(index) {
    var current = pathData();
    var active = normalizeGroupTags(index || {}, current.tags || []);
    qsa('a[href*="/collections/"]').forEach(function (anchor) {
      if (anchor.matches('[data-integy-v188-model-filter-row],[data-integy-static-model-filter-row],[data-integy-v427-model-chip]') || anchor.closest('[data-integy-v188-model-filter-list]')) return;
      var repaired = normalizedCollectionUrl(anchor.href, index || {});
      if (repaired) anchor.href = repaired;
      var parsed = tagsFromUrl(anchor.href);
      var handle = parsed && parsed.tags.length ? canonical(index || {}, parsed.tags[parsed.tags.length - 1]) : '';
      if (!handle) return;
      var selected = active.indexOf(handle) >= 0;
      if (anchor.getAttribute('role') === 'radio' || anchor.getAttribute('role') === 'checkbox' || /filter/i.test(anchor.className || '')) {
        anchor.setAttribute('role', filterGroup(handle) ? 'radio' : 'checkbox');
        anchor.setAttribute('aria-checked', selected ? 'true' : 'false');
        anchor.setAttribute('aria-pressed', selected ? 'true' : 'false');
        anchor.setAttribute('data-integy-v426-filter-group', filterGroup(handle) || 'supplemental');
        anchor.classList.toggle('is-active', selected);
      }
    });
  }

  function filterLinkNavigation(event) {
    var anchor = event.target && event.target.closest ? event.target.closest('a[href*="/collections/"]') : null;
    if (!anchor || event.defaultPrevented) return;
    if (anchor.matches('[data-integy-v188-model-filter-row],[data-integy-static-model-filter-row],[data-integy-v427-model-chip]') || anchor.closest('[data-integy-v188-model-filter-list]')) return;
    var repaired = normalizedCollectionUrl(anchor.href, {});
    if (!repaired) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    emitEvent('filter_selected', { href: repaired, source: 'normalized-link' });
    location.assign(repaired);
  }

  function filterKeyboardNavigation(event) {
    if (event.key !== ' ' && event.key !== 'Spacebar') return;
    var anchor = event.target && event.target.closest ? event.target.closest('a[data-integy-v307-option]') : null;
    if (!anchor || !anchor.href) return;
    event.preventDefault();
    anchor.click();
  }

  function emitEvent(name, detail) {
    try { document.dispatchEvent(new CustomEvent('integy:analytics', { detail: { event: name, data: detail || {} } })); } catch (error) {}
    if (window.dataLayer && typeof window.dataLayer.push === 'function') window.dataLayer.push({ event: 'integy_' + name, integy: detail || {} });
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[char];
    });
  }



  /* V436: reconcile every visible/native card to the exact V37 canonical URL.
     The previous owner only guaranteed canonical URLs for cards it rebuilt;
     cards retained from Shopify's initial grid could keep punctuated 404 paths. */
  function recordMap(index) {
    return index && index.products && !Array.isArray(index.products) ? index.products : Object.create(null);
  }
  function cardSku(card) {
    if (!card) return '';
    var explicit = card.getAttribute('data-sku') || card.getAttribute('data-product-sku') || '';
    var node = qs('.integy-product-card-sku,[data-product-sku],.productitem--sku', card);
    var text = explicit || (node ? clean(node.textContent || '') : '');
    var match = String(text).match(/(?:SKU\s*:?\s*)?([A-Z0-9][A-Z0-9._/-]{1,})/i);
    return match ? String(match[1]).toUpperCase().replace(/\s+/g, '') : '';
  }
  function rewriteCardUrl(card, index) {
    var sku = cardSku(card);
    var record = sku && recordMap(index)[sku];
    var url = record && String(record.url || '');
    if (!url || url.indexOf('/products/') !== 0) return false;
    url = v626LocalizedPath(url);
    qsa('a[href*="/products/"]', card).forEach(function (anchor) { anchor.setAttribute('href', url); });
    ['data-product-quickshop-url','data-integy-v426-product-url','data-product-url','data-product-href'].forEach(function (name) {
      if (card.hasAttribute(name)) card.setAttribute(name, url);
      qsa('[' + name + ']', card).forEach(function (node) { node.setAttribute(name, url); });
    });
    card.setAttribute('data-integy-v436-canonical-url', url);
    return true;
  }
  function rewriteAllCardUrls(index, scope) {
    qsa('[data-product-item],.productgrid--item', scope || document).forEach(function (card) { rewriteCardUrl(card, index); });
  }
  function startCanonicalUrlObserver(index) {
    rewriteAllCardUrls(index, document);
    if (!window.MutationObserver || document.documentElement.hasAttribute('data-integy-v436-url-observer')) return;
    document.documentElement.setAttribute('data-integy-v436-url-observer', 'true');
    var timer = 0;
    new MutationObserver(function (mutations) {
      if (!mutations.some(function (mutation) { return mutation.addedNodes && mutation.addedNodes.length; })) return;
      clearTimeout(timer);
      timer = setTimeout(function () { rewriteAllCardUrls(index, document); }, 80);
    }).observe(document.body, { childList: true, subtree: true });
  }

  function safeMoney(value, valueIsCents) {
    value = clean(value).replace(/[$,]/g, '');
    if (!value) return '';
    var n = Number(value);
    if (!Number.isFinite(n)) return '';
    var cents = valueIsCents ? Math.round(n) : Math.round(n * 100);
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      var format = (window.theme && window.theme.moneyFormat) || window.Shopify.money_format || '${{amount}}';
      try { return window.Shopify.formatMoney(cents, format); } catch (error) {}
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function priceText(value) {
    return safeMoney(value, false);
  }

  /* INTEGY V528 — dynamically generated canonical filter cards do not have
     Liquid's compare-at price available in the V454 filter index. Enrich only
     dynamic cards as they approach the viewport using Shopify's same-origin
     product JSON endpoint. Requests are concurrency-limited and cached for the
     current page session so filtered cards retain original price + Save %. */
  var v528PriceCache = Object.create(null);
  var v528PriceQueue = [];
  var v528PriceActive = 0;

  /* V576: live stock refill keeps indexed stock pages dense after Shopify live
     verification rejects stale indexed availability. Rescue pools are page-disjoint
     so the same cached-opposite candidate is not intentionally reused on adjacent pages. */
  var v576StockRefillState = null;
  var V576_STOCK_REFILL_BATCH = 8;
  var V576_STOCK_RESCUE_PER_PAGE = FILTER_PAGE_SIZE * 3;
  var v528PriceObserver = null;

  function v528ProductEndpoint(value) {
    try {
      var url = new URL(value || '', location.origin);
      var match = url.pathname.match(/\/products\/([^/?#]+)/i);
      return match ? v626LocalizedPath('products/' + match[1] + '.js') : '';
    } catch (error) { return ''; }
  }

  function v528FinishPriceJob(key, result) {
    var entry = v528PriceCache[key];
    if (!entry) return;
    entry.state = 'done';
    entry.result = result || null;
    var callbacks = entry.callbacks || [];
    entry.callbacks = [];
    callbacks.forEach(function (callback) {
      try { callback(entry.result); } catch (error) {}
    });
  }

  /* V719: a stalled product response must not occupy a queue slot forever.
     Timeout includes JSON parsing; abort also frees the network request. */
  function v719FetchProductJson(endpoint) {
    return new Promise(function (resolve, reject) {
      var controller = window.AbortController ? new AbortController() : null;
      var settled = false;
      function finish(error, product) {
        if (settled) return;
        settled = true;
        window.clearTimeout(timer);
        if (error) reject(error); else resolve(product);
      }
      var timer = window.setTimeout(function () {
        finish(new Error('Product verification timed out'));
        if (controller) controller.abort();
      }, 12000);
      Promise.resolve().then(function () {
        return fetch(endpoint, {
          credentials: 'same-origin', cache: 'no-cache',
          headers: { 'Accept': 'application/json' },
          signal: controller ? controller.signal : undefined
        });
      }).then(function (response) {
        if (!response.ok) throw new Error('Product verification unavailable');
        return response.json();
      }).then(function (product) { finish(null, product); }, function (error) { finish(error); });
    });
  }

  function v528PumpPriceQueue() {
    /* INTEGY V634 — indexed stock pages verify 72 visible candidates before
       first paint. Eight same-origin product JSON requests keeps that atomic
       handoff practical without increasing request pressure site-wide. */
    var v634MaxConcurrent = (root.classList.contains('integy-v536-index-stock-owned') && requestedStockMode() !== 'all') ? 8 : 4;
    while (v528PriceActive < v634MaxConcurrent && v528PriceQueue.length) {
      (function (job) {
        v528PriceActive += 1;
        v719FetchProductJson(job.endpoint).then(healFacetMetadata)
          .then(function (product) {
            var variants = product && Array.isArray(product.variants) ? product.variants : [];
            var sku = String(job.sku || '').toUpperCase().replace(/\s+/g, '');
            var variant = null;
            if (sku) {
              variant = variants.find(function (candidate) {
                return String(candidate && candidate.sku || '').toUpperCase().replace(/\s+/g, '') === sku;
              }) || null;
            }
            if (!variant) variant = variants.find(function (candidate) { return candidate && candidate.available; }) || variants[0] || null;
            var price = variant ? Number(variant.price || 0) : 0;
            var compare = variant ? Number(variant.compare_at_price || 0) : 0;
            var anyAvailable = variants.some(function (candidate) { return !!(candidate && candidate.available); });
            v528FinishPriceJob(job.key, { price: price, compare: compare, available: anyAvailable, variantId: variant && variant.id ? String(variant.id) : '', variantCount: variants.length });
          })
          .catch(function () { v528FinishPriceJob(job.key, null); })
          .then(function () {
            v528PriceActive = Math.max(0, v528PriceActive - 1);
            v528PumpPriceQueue();
          });
      })(v528PriceQueue.shift());
    }
  }

  function v528RequestPrice(card, callback) {
    var endpoint = v528ProductEndpoint(card && card.getAttribute('data-integy-v528-price-url'));
    var sku = card && (card.getAttribute('data-sku') || card.getAttribute('data-product-sku') || '');
    if (!endpoint) { callback(null); return; }
    var key = endpoint + '|' + String(sku || '').toUpperCase();
    var cached = v528PriceCache[key];
    if (cached && cached.state === 'done') { callback(cached.result); return; }
    if (cached && cached.state === 'pending') { cached.callbacks.push(callback); return; }
    v528PriceCache[key] = { state: 'pending', callbacks: [callback], result: null };
    v528PriceQueue.push({ key: key, endpoint: endpoint, sku: sku });
    v528PumpPriceQueue();
  }

  function v549RefreshLiveStockSummary(scope) {
    /* V681: V681/V677 large-stock renderer owns the exact total and page slice.
       Legacy verification observers must not replace that authoritative status. */
    if (window.IntegyV681LargeCollectionStockOwner || window.IntegyV677LargeCollectionStockOwner ||
        window.IntegyV651LargeStockOwnerActive || document.querySelector('[data-integy-v681-authoritative-owner]')) return;
    var current = pathData();
    var mode = requestedStockMode();
    if (mode === 'all') return;
    var grid = (scope && scope.closest && scope.closest('[data-productgrid-items], .productgrid--items')) || qs('[data-productgrid-items], .productgrid--items');
    if (!grid) return;
    var pending = qsa('[data-integy-v548-stock-verified="false"]', grid);
    if (pending.length) return;
    var visible = qsa('[data-product-item], .productgrid--item', grid).filter(function (item) {
      return !item.hidden && item.getAttribute('aria-hidden') !== 'true' && (!item.style || item.style.display !== 'none');
    }).length;
    qsa('[data-integy-v449-stock-status]').forEach(function (status) {
      var unknown = qsa('[data-integy-v548-stock-verified="error"]', grid).length;
      var verified = Math.max(0, visible - unknown);
      status.textContent = verified + ' live ' + (mode === 'out' ? 'out-of-stock' : 'in-stock') + ' match' + (verified === 1 ? '' : 'es') + ' on this page' + (unknown ? ' · ' + unknown + ' awaiting availability confirmation' : '');
      status.setAttribute('data-integy-v549-live-page-count', String(visible));
    });
  }


  function v576VisibleLiveCards(grid) {
    return qsa('[data-product-item], .productgrid--item', grid || document).filter(function (card) {
      return !card.hidden && card.getAttribute('aria-hidden') !== 'true' && (!card.style || card.style.display !== 'none') && card.getAttribute('data-integy-v548-stock-verified') === 'true';
    });
  }

  function v576PendingLiveCards(grid) {
    return qsa('[data-integy-v548-stock-verified="false"]', grid || document);
  }

  function v576AppendRescueCard(state, record) {
    if (!state || !state.grid || !record) return false;
    var key = v576RecordIdentity(record);
    if (!key || state.rendered[key]) return false;
    state.rendered[key] = true;
    var template = document.createElement('template');
    template.innerHTML = cardHtml(record, FILTER_PAGE_SIZE + state.appended + 1);
    var card = template.content.firstElementChild;
    if (!card) return false;
    state.appended += 1;
    card.setAttribute('data-integy-v576-stock-rescue', 'true');
    state.grid.appendChild(card);
    rewriteAllCardUrls(state.index, card);
    return true;
  }

  function v634SettleStockGrid(grid, reason) {
    if (!grid) return;
    grid.setAttribute('data-integy-v634-stock-settled', 'true');
    grid.classList.remove('integy-v634-stock-settling');
    if (reason) grid.setAttribute('data-integy-v634-stock-settle-reason', reason);
    try {
      document.dispatchEvent(new CustomEvent('integy:v634:stock-settled', { detail: { reason: reason || 'verified' } }));
    } catch (error) {}
  }

  function v576MaybeRefillStockGrid(grid) {
    var state = v576StockRefillState;
    if (!state || !state.grid || state.grid !== grid || !grid.isConnected) return;
    if (state.key !== grid.getAttribute('data-integy-v307-key')) return;
    if (requestedStockMode() === 'all') return;
    if (v576PendingLiveCards(grid).length) return;

    /* V719: do not multiply rescue requests when the network is failing. */
    if (qs('[data-integy-v548-stock-verified="error"]', grid)) {
      grid.classList.remove('integy-v576-stock-refill-pending');
      v634SettleStockGrid(grid, 'verification-incomplete');
      return;
    }
    var visible = v576VisibleLiveCards(grid).length;
    if (visible >= state.target || state.rescueIndex >= state.rescuePool.length) {
      grid.classList.remove('integy-v576-stock-refill-pending');
      grid.setAttribute('data-integy-v576-live-page-count', String(visible));
      grid.setAttribute('data-integy-v576-stock-refill-complete', 'true');
      v549RefreshLiveStockSummary(grid);
      v634SettleStockGrid(grid, visible >= state.target ? 'verified-page-full' : 'rescue-exhausted');
      return;
    }

    var room = Math.max(0, state.target - visible);
    var added = 0;
    while (state.rescueIndex < state.rescuePool.length && added < V576_STOCK_REFILL_BATCH && added < room) {
      var record = state.rescuePool[state.rescueIndex++];
      if (v576AppendRescueCard(state, record)) added += 1;
    }
    if (!added) {
      grid.classList.remove('integy-v576-stock-refill-pending');
      grid.setAttribute('data-integy-v576-live-page-count', String(visible));
      grid.setAttribute('data-integy-v576-stock-refill-complete', 'true');
      v549RefreshLiveStockSummary(grid);
      v634SettleStockGrid(grid, 'no-more-rescue-candidates');
      return;
    }
    grid.classList.add('integy-v576-stock-refill-pending');
    v528ObserveDynamicPrices(grid);
  }

  function v528ApplyDynamicPrice(card, pricing) {
    if (!card || !card.isConnected) return;
    card.setAttribute('data-integy-v528-price-state', 'done');
    var liveMode = requestedStockMode();
    if (!pricing) {
      card.setAttribute('data-integy-v548-stock-verified', 'error');
      /* V719: a request failure is unknown stock, not proof of a missing SKU.
         Keep a readable product link, but never enable purchase from stale data. */
      card.removeAttribute('data-integy-v576-live-product-missing');
      card.setAttribute('data-product-available', 'unknown');
      card.hidden = false;
      var failedStock = qs('.integy-v426-card-stock', card);
      if (failedStock) { failedStock.className = 'integy-v426-card-stock'; failedStock.textContent = 'Check availability'; }
      var failedPrice = qs('.integy-v410-card-price__current', card);
      if (failedPrice) failedPrice.textContent = 'See product price';
      qsa('[data-integy-v528-compare-price],[data-integy-v528-saving],[data-integy-v528-original-label]', card).forEach(function (node) { node.hidden = true; });
      var failedActions = qs('.integy-v547-direct-actions', card);
      var failedUrl = card.getAttribute('data-integy-v528-price-url') || '';
      if (failedActions) failedActions.innerHTML = '<a class="productitem--action-trigger button-primary integy-v547-choose-options" href="' + escapeHtml(failedUrl) + '">View Details</a>';
      var failedGrid = card.closest && card.closest('[data-productgrid-items], .productgrid--items');
      if (failedGrid && !qs('[data-integy-v548-stock-verified="false"]', failedGrid)) { failedGrid.classList.remove('integy-v548-live-stock-pending'); v549RefreshLiveStockSummary(failedGrid); v576MaybeRefillStockGrid(failedGrid); }
      return;
    }
    /* V719: current and compare-at must come from the same live variant. */
    var current = Number(pricing.price || 0);
    var compare = Number(pricing.compare || 0);
    card.setAttribute('data-integy-v528-price-cents', String(current));
    var currentNode = qs('.integy-v410-card-price__current', card);
    if (currentNode) currentNode.textContent = safeMoney(current, true);
    var compareNode = qs('[data-integy-v528-compare-price]', card);
    var originalLabel = qs('[data-integy-v528-original-label]', card);
    var savingNode = qs('[data-integy-v528-saving]', card);
    var priceRoot = qs('.integy-v528-dynamic-price', card);
    if (compare > current && current > 0) {
      if (compareNode) { compareNode.textContent = safeMoney(compare, true); compareNode.hidden = false; }
      if (originalLabel) originalLabel.hidden = false;
      if (savingNode) {
        var percent = Math.max(1, Math.round(((compare - current) * 100) / compare));
        savingNode.textContent = 'Save ' + percent + '%';
        savingNode.hidden = false;
      }
      if (priceRoot) priceRoot.classList.add('integy-v410-card-price--sale');
    } else {
      if (compareNode) { compareNode.hidden = true; compareNode.textContent = ''; }
      if (originalLabel) originalLabel.hidden = true;
      if (savingNode) { savingNode.hidden = true; savingNode.textContent = ''; }
      if (priceRoot) priceRoot.classList.remove('integy-v410-card-price--sale');
    }
    card.setAttribute('data-product-available', pricing.available ? 'true' : 'false');
    var stockNode = qs('.integy-v426-card-stock', card);
    if (stockNode) {
      stockNode.textContent = pricing.available ? 'In stock' : 'Sold out';
      stockNode.classList.toggle('is-in-stock', !!pricing.available);
      stockNode.classList.toggle('is-sold-out', !pricing.available);
    }
    var actionWrap = qs('.integy-v547-direct-actions', card);
    if (actionWrap) {
      var productUrl = card.getAttribute('data-integy-v528-price-url') || '#';
      if (!pricing.available) actionWrap.innerHTML = '<button class="productitem--action-trigger button-primary integy-v547-direct-atc is-sold-out" type="button" disabled>Sold Out</button>';
      else if (Number(pricing.variantCount || 0) === 1 && pricing.variantId) actionWrap.innerHTML = '<button class="productitem--action-trigger button-primary integy-v547-direct-atc" type="button" data-integy-v547-atc data-variant-id="' + escapeHtml(pricing.variantId) + '" data-product-url="' + escapeHtml(productUrl) + '">Add to Cart</button>';
      else actionWrap.innerHTML = '<a class="productitem--action-trigger button-primary integy-v547-choose-options" href="' + escapeHtml(productUrl) + '" data-product-page-link>Choose Options</a>';
    }
    card.setAttribute('data-integy-v548-stock-verified', 'true');
    if ((liveMode === 'in' && !pricing.available) || (liveMode === 'out' && pricing.available)) card.hidden = true;
    else if (liveMode !== 'all') card.hidden = false;
    var verifiedGrid = card.closest && card.closest('[data-productgrid-items], .productgrid--items');
    if (verifiedGrid && !qs('[data-integy-v548-stock-verified="false"]', verifiedGrid)) { verifiedGrid.classList.remove('integy-v548-live-stock-pending'); v549RefreshLiveStockSummary(verifiedGrid); v576MaybeRefillStockGrid(verifiedGrid); }
  }

  function v528HydratePriceCard(card) {
    if (!card || card.getAttribute('data-integy-v528-price-state') === 'loading' || card.getAttribute('data-integy-v528-price-state') === 'done') return;
    card.setAttribute('data-integy-v528-price-state', 'loading');
    v528RequestPrice(card, function (pricing) { v528ApplyDynamicPrice(card, pricing); });
  }

  function v548VerifyNativeStockCards(scope) {
    var mode = requestedStockMode();
    if (mode === 'all') return;
    qsa('[data-product-item], .productgrid--item', scope || document).forEach(function (card) {
      if (card.getAttribute('data-integy-v528-price-enrich') === 'true') return;
      var explicit = card.getAttribute('data-product-available');
      if (explicit !== 'true' && explicit !== 'false') return;
      var available = explicit === 'true';
      card.setAttribute('data-integy-v548-stock-verified', 'true');
      card.hidden = (mode === 'in' && !available) || (mode === 'out' && available);
    });
    v549RefreshLiveStockSummary(scope || document);
  }

  function v528ObserveDynamicPrices(scope) {
    var cards = qsa('[data-integy-v528-price-enrich="true"]', scope || document).filter(function (card) {
      return card.getAttribute('data-integy-v528-price-state') !== 'loading' && card.getAttribute('data-integy-v528-price-state') !== 'done';
    });
    if (!cards.length) return;
    /* V565: whenever a stock mode is active, verify every dynamic/indexed card on
       the current page against live Shopify product JSON immediately. Cached index
       availability may order candidates but never decides what the shopper sees. */
    var current = pathData();
    if (requestedStockMode() !== 'all') {
      var grid = qs('[data-productgrid-items], .productgrid--items');
      if (grid) grid.classList.add('integy-v548-live-stock-pending');
      cards.forEach(function (card) { card.setAttribute('data-integy-v548-stock-verified', 'false'); v528HydratePriceCard(card); });
      return;
    }
    if (!window.IntersectionObserver) { cards.slice(0, 16).forEach(v528HydratePriceCard); return; }
    if (!v528PriceObserver) {
      v528PriceObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          v528PriceObserver.unobserve(entry.target);
          v528HydratePriceCard(entry.target);
        });
      }, { rootMargin: '800px 0px' });
    }
    cards.forEach(function (card) { v528PriceObserver.observe(card); });
  }

  // V467: the scoped filter index intentionally uses Integy's legacy product-image host.
  // Accept only known first-party/Shopify image origins; never render arbitrary external URLs.
  function trustedProductImage(value) {
    value = String(value || '').trim();
    if (/^\/\/cdn\.shopify\.com\//i.test(value)) return location.protocol + value;
    if (/^https?:\/\/[^/]*(?:cdn\.shopify\.com|shopifycdn\.com)\//i.test(value)) return value;
    if (/^\/cdn\/shop\//i.test(value)) return value;
    if (/^https:\/\/ssl-firewall-6zh26qy9vm\.integy\.com\/product-images\/[a-z0-9._%+-]+\.(?:avif|webp|jpe?g|png)(?:[?#].*)?$/i.test(value)) return value;
    if (/^https:\/\/(?:www\.)?integy\.com\/product-images\/[a-z0-9._%+-]+\.(?:avif|webp|jpe?g|png)(?:[?#].*)?$/i.test(value)) return value;
    return '';
  }

  function displayType(record) {
    return clean(record && (record.type || record.product_type || record.display_type));
  }

  function cardHtml(record, index) {
    var title = escapeHtml(record.title || '');
    var sku = escapeHtml(record.sku || '');
    var url = escapeHtml(record.url || '');
    var rawImage = String(record.image || '');
    var image = escapeHtml(trustedProductImage(rawImage));
    var price = escapeHtml(priceText(record.price || ''));
    var priceCents = Math.max(0, Math.round((Number(record.price || 0) || 0) * 100));
    var shortType = displayType(record);
    var available = record.available !== false;
    var genericFitHandles = /^(?:all-integy-hop-up-parts|all-products|products|bargain-outlet-center|boats|parts-for-more-rc-vehicles|integy-hop-ups-for-more-rc-vehicles|one-of-a-kind-open-box-scratch-dent|(?:hop-up-parts-for|hopups-for|parts-for)-(?:traxxas|arrma|axial|hpi(?:-racing)?|losi|tamiya))$/i;
    var fits = (record.compatible_collections || []).filter(function (handle) {
      return !genericFitHandles.test(String(handle || '').trim());
    }).slice(0, 2).map(function (handle) {
      return String(handle || '')
        .replace(/^hop-up-parts-for-/, '')
        .replace(/^hopups-for-/, '')
        .replace(/^parts-for-/, '')
        .replace(/-/g, ' ');
    }).join(', ');
    var loading = index <= 10 ? 'eager' : 'lazy';
    var img = image
      ? '<img class="productitem--image-primary integy-v104-collection-image integy-v106-collection-image integy-v115-collection-image" src="' + image + '" alt="' + title + '" loading="' + loading + '" decoding="async" width="480" height="480" data-integy-v467-index-image="true"' + (index === 0 ? ' fetchpriority="high"' : '') + '>'
      : '<span class="placeholder--image" aria-hidden="true"></span>';
    var directAction = '<div class="productitem--actions integy-v547-direct-actions" data-product-actions><button class="productitem--action-trigger button-primary integy-v547-direct-atc is-pending" type="button" data-integy-v547-atc-pending disabled>Checking…</button></div>';

    return '' +
      '<div class="productgrid--item integy-v104-collection-card-lite integy-v115-collection-card-lite integy-v307-canonical-card imagestyle--natural" data-product-item data-integy-v460-dynamic-card="canonical" data-integy-v528-price-enrich="true" data-integy-v528-price-url="' + url + '" data-integy-v528-price-cents="' + priceCents + '" data-sku="' + sku + '" data-integy-v426-product-url="' + url + '" data-integy-v307-card-index="' + index + '" data-product-available="' + (available ? 'true' : 'false') + '">' +
        '<div class="productitem" data-product-item-content>' +
          '<div class="productitem__container">' +
            '<div class="productitem__image-container">' +
              '<a class="productitem--image-link" href="' + url + '" tabindex="-1" data-product-page-link aria-label="' + title + '">' +
                '<figure class="productitem--image" data-product-item-image>' + img + '<span class="visually-hidden">' + title + '</span></figure>' +
              '</a>' +
            '</div>' +
            '<div class="productitem--info">' +
              '<h2 class="productitem--title"><a href="' + url + '" data-product-page-link>' + title + '</a></h2>' +
              '<div class="integy-v557-card-statusline integy-v559-card-statusline" data-integy-v559-card-status>' +
                '<div class="integy-v426-card-stock integy-v549-card-stock ' + (available ? 'is-in-stock' : 'is-sold-out') + '">' + (available ? 'In stock' : 'Sold out') + '</div>' +
                (sku ? '<div class="integy-product-card-sku" title="' + sku + '">' + sku + '</div>' : '') +
              '</div>' +
              (price ? '<div class="price productitem__price integy-v410-card-price integy-v528-dynamic-price"><div class="integy-v410-card-price__main"><span class="visually-hidden">Current price</span><span class="money integy-v410-card-price__current" data-price>' + price + '</span><span class="visually-hidden" data-integy-v528-original-label hidden>Original price</span><s class="money integy-v410-card-price__compare" data-integy-v528-compare-price hidden></s></div><span class="integy-v410-card-price__saving" data-integy-v528-saving hidden></span></div>' : '') +
              directAction +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  function ensureGrid() {
    var grid = qs('[data-productgrid-items], .productgrid--items');
    if (grid) return grid;
    grid = document.createElement('div');
    grid.className = 'productgrid--items products-per-row-4 integy-v307-canonical-grid';
    grid.setAttribute('data-html', 'productgrid-items');
    grid.setAttribute('data-productgrid-items', '');
    var noResults = qs('.productgrid--no-results');
    var pagination = qs('.pagination--container, .pagination');
    if (noResults && noResults.parentNode) {
      noResults.parentNode.insertBefore(grid, noResults.nextSibling);
    } else if (pagination && pagination.parentNode) {
      pagination.parentNode.insertBefore(grid, pagination);
    } else {
      var wrapper = qs('.productgrid--wrapper, .productgrid--outer, main');
      if (wrapper) wrapper.appendChild(grid);
    }
    return grid;
  }

  function updateVisibleCounts(count, labels) {
    var text = count + ' ' + (count === 1 ? 'product' : 'products');
    qsa('.collection--product-count, .productgrid--count, .integy-collection-meta .integy-chip').forEach(function (el) {
      if (!el || !/\bproducts?\b/i.test(el.textContent || '')) return;
      el.textContent = text;
      el.setAttribute('data-integy-v307-count', String(count));
      if (labels && labels.length) el.setAttribute('data-integy-v307-filters', labels.join(', '));
    });
    qsa('[data-integy-v449-stock-status]').forEach(function (status) {
      status.textContent = count + ' matching item' + (count === 1 ? '' : 's');
      status.setAttribute('data-integy-v536-authoritative-stock-count', String(count));
    });
  }

  function activeLabels(index, tags) {
    return canonicalTags(index, tags).map(function (tag) {
      return index.labels && index.labels[tag] ? index.labels[tag] : tag.replace(/-/g, ' ');
    });
  }

  function shouldSuppressOption(index, collection, data, handle, count, active) {
    handle = handleize(handle);
    if (!handle) return true;
    /* Always retain an active row so a bookmarked/legacy URL can be cleared. */
    if (active) return false;
    var scoped = falsePositiveCollectionHandles[handleize(collection)] || null;
    if (scoped && scoped[handle]) return true;
    if (data && data.hidden_filters) {
      if (Array.isArray(data.hidden_filters) && data.hidden_filters.indexOf(handle) >= 0) return true;
      if (!Array.isArray(data.hidden_filters) && data.hidden_filters[handle]) return true;
    }
    if (!count || count < 1) return true;
    /* V498: the broad canonical data contains title-derived phrases, brands,
       dimensions, and near-SKU tags. Only explicit buyer attributes belong in
       the Part / scale / color list; stock is owned by the dedicated toolbar. */
    var buyerGroup = filterGroup(handle);
    if (!buyerGroup || !buyerVisibleGroups[buyerGroup]) return true;
    return false;
  }

  function optionOrder(data) {
    var handles = unique(preferredOrder.concat(Object.keys(data && data.counts ? data.counts : {})));
    return handles.filter(function (handle) {
      return !!(data && data.counts && data.counts[handle]);
    });
  }

  function optionHtml(index, collection, active, handle, count, isActive) {
    var nextTags = nextTagsForSelection(index, active, handle, isActive);
    var label = index.labels && index.labels[handle] ? index.labels[handle] : handle.replace(/-/g, ' ');
    var group = filterGroup(handle);
    return '' +
      '<a class="integy-v27-filter-chip integy-v31-checkbox-filter integy-v201-static-filter-row integy-v218-static-filter-row integy-v294-filter-row integy-v426-filter-chip' + (isActive ? ' is-active integy-v31-checkbox-filter--active' : '') + '"' +
        ' href="' + escapeHtml(buildUrl(collection, nextTags)) + '"' +
        ' role="' + (group ? 'radio' : 'checkbox') + '"' +
        ' aria-checked="' + (isActive ? 'true' : 'false') + '" aria-pressed="' + (isActive ? 'true' : 'false') + '"' +
        ' data-handle="' + escapeHtml(handle) + '"' +
        ' data-integy-v426-filter-group="' + escapeHtml(group || 'supplemental') + '"' +
        ' data-tag-handle="' + escapeHtml(handle) + '"' +
        ' data-integy-v294-filter-row' +
        ' data-integy-v307-option="' + escapeHtml(handle) + '"' +
        ' data-integy-v307-count="' + String(count) + '"' +
        ' data-integy-v307-direct-nav>' +
        '<span class="integy-v201-filter-box integy-v200-filter-box" aria-hidden="true"></span>' +
        '<span class="integy-v201-filter-label">' + escapeHtml(label) + '</span>' +
        '<span class="filtered-product-count filtered-product-count--hidden" data-filtered-product-count></span>' +
      '</a>';
  }

  function renderCanonicalRows(index, collection, data, currentTags) {
    var list = qs('[data-integy-v200-static-part-filter-list],.integy-v200-static-part-filter-list,.integy-v201-static-part-filter-list');
    if (!list || !data || !data.counts) return;
    var active = normalizeGroupTags(index, currentTags);
    var activePartType = active.find(function (tag) { return filterGroup(tag) === 'part_type'; }) || '';
    var rows = [];
    optionOrder(data).forEach(function (handle) {
      if (!(index.labels && index.labels[handle])) return;
      var isActive = active.indexOf(handle) >= 0;
      /* V564: once a Part Type is selected, keep the active row but suppress the
         dozens of alternate Part Type rows. Scale / Color / Sale remain visible.
         Clearing the active Part Type restores the full Part Type chooser. */
      if (activePartType && filterGroup(handle) === 'part_type' && handle !== activePartType) return;
      if (shouldSuppressOption(index, collection, data, handle, data.counts[handle], isActive)) return;
      var nextTags = nextTagsForSelection(index, active, handle, isActive);
      var count = isActive
        ? facetRecordsFor(index, collection, active).records.length
        : facetRecordsFor(index, collection, nextTags).records.length;
      if (!count && !isActive) return;
      rows.push(optionHtml(index, collection, active, handle, count, isActive));
    });
    /* INTEGY V527 — preserve valid Liquid fallback filters when the canonical
       index returns no dynamic rows. The V501 owner previously replaced the
       server-rendered list with an empty string and hid the whole group, so a
       transient/missing index result could make every part filter disappear.
       Dynamic canonical rows still replace the fallback whenever they exist. */
    var existingLinks = qsa('a[href]', list);
    var hasExistingFallback = existingLinks.length > 0 && (list.getAttribute('data-integy-v307-owner') !== 'true' || list.getAttribute('data-integy-v527-fallback-retained') === 'true');
    var details = list.closest && list.closest('[data-integy-v200-static-part-filter-details]');

    if (rows.length) {
      list.innerHTML = rows.join('');
      list.removeAttribute('data-integy-v527-fallback-retained');
      if (details) {
        details.hidden = false;
        details.classList.remove('integy-v309-empty-part-filters');
        details.setAttribute('data-integy-v309-has-options', 'true');
      }
    } else if (hasExistingFallback) {
      list.setAttribute('data-integy-v527-fallback-retained', 'true');
      if (details) {
        details.hidden = false;
        details.classList.remove('integy-v309-empty-part-filters');
        details.setAttribute('data-integy-v309-has-options', 'true');
      }
    } else {
      list.innerHTML = '';
      if (details) {
        details.hidden = true;
        details.classList.add('integy-v309-empty-part-filters');
        details.setAttribute('data-integy-v309-has-options', 'false');
      }
    }
    list.setAttribute('data-integy-v294-ready', 'true');
    list.setAttribute('data-integy-v295-state', 'ready');
    list.setAttribute('data-integy-v297-state', 'ready');
    list.setAttribute('data-integy-v298-state', 'ready');
    list.setAttribute('data-integy-v307-state', 'ready');
    list.setAttribute('data-integy-v307-owner', 'true');
  }

  function markReady() {
    root.classList.add(
      'integy-v294-filter-ready',
      'integy-v295-filter-ready',
      'integy-v297-filter-ready',
      'integy-v298-filter-ready',
      'integy-v307-filter-ready',
      'integy-v309-filter-ready',
      'integy-v426-filter-ready',
      'integy-v429-filter-ready'
    );
    qsa('.productgrid--sidebar,[data-productgrid-sidebar]').forEach(function (sidebar) {
      sidebar.setAttribute('data-integy-v294-ready', 'true');
      sidebar.setAttribute('data-integy-v307-ready', 'true');
      sidebar.setAttribute('data-integy-v309-ready', 'true');
    });
    qsa('[data-integy-static-model-filter-row], [data-integy-v294-filter-row], .integy-v294-filter-row').forEach(function (row) {
      row.setAttribute('data-integy-v294-ready', 'true');
    });
  }

  function hideEmptyCanonicalShell() {
    qsa('[data-integy-v200-static-part-filter-details]').forEach(function (details) {
      var list = qs('[data-integy-v200-static-part-filter-list], [data-integy-v201-static-part-filter-list]', details);
      var hasLinks = list && qsa('a[href]', list).length > 0;
      if (hasLinks) return;
      details.hidden = true;
      details.classList.add('integy-v309-empty-part-filters');
      details.setAttribute('data-integy-v309-has-options', 'false');
    });
  }

  function ensureActiveChips(index, collection, tags) {
    if (!tags.length) return;
    var existing = qs('.productgrid--filters');
    var existingLinks = existing ? qsa('a', existing).length : 0;
    var labels = activeLabels(index, tags);
    var existingText = existing ? clean(existing.textContent || '').toLowerCase() : '';
    var hasLabels = labels.length && labels.every(function (label) {
      return existingText.indexOf(String(label || '').toLowerCase()) >= 0;
    });
    if (existing && existingLinks >= tags.length && hasLabels) return;
    qsa('.integy-v307-active-filters').forEach(function (node) {
      if (node.parentNode) node.parentNode.removeChild(node);
    });
    var holder = document.createElement('div');
    holder.className = 'productgrid--filters integy-v307-active-filters';
    var current = canonicalTags(index, tags);
    holder.innerHTML = '<ul class="filter-group--grid">' + current.map(function (tag) {
      var remaining = current.filter(function (candidate) { return candidate !== tag; });
      var href = buildUrl(collection, remaining);
      var label = index.labels && index.labels[tag] ? index.labels[tag] : tag.replace(/-/g, ' ');
      return '<li class="filter-item--grid"><a href="' + escapeHtml(href) + '"><span class="filter-text">' + escapeHtml(label) + '</span><span class="filter-icon--remove" aria-hidden="true">x</span></a></li>';
    }).join('') + (current.length > 1 ? '<li class="filter-item--grid-simple"><a href="' + escapeHtml(buildUrl(collection, [])) + '">Clear all</a></li>' : '') + '</ul>';
    var anchor = qs('.productgrid--items, [data-productgrid-items], .productgrid--no-results, .pagination--container, .pagination');
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(holder, anchor);
  }

  function hideRow(row) {
    row.classList.add('integy-v307-hidden-zero', 'integy-v294-zero-hidden');
    row.style.display = 'none';
    var anchor = row.matches && row.matches('a') ? row : qs('a', row);
    if (anchor) {
      anchor.setAttribute('aria-disabled', 'true');
      anchor.tabIndex = -1;
    }
  }

  function rowHandle(row) {
    var anchor = row.matches && row.matches('a') ? row : qs('a', row);
    return handleize(
      row.getAttribute('data-handle') ||
      row.getAttribute('data-tag-handle') ||
      row.getAttribute('data-tag-label') ||
      (anchor && (anchor.getAttribute('data-tag-handle') || anchor.getAttribute('data-handle') || anchor.textContent)) ||
      ''
    );
  }

  function markFilterRows(index, collection, data, currentTags) {
    if (!data || !data.counts) return;
    var active = normalizeGroupTags(index, currentTags);
    var activePartType = active.find(function (tag) { return filterGroup(tag) === 'part_type'; }) || '';
    qsa('.filter-item[data-handle], [data-tag-handle], [data-handle], a[data-integy-v294-filter-row], a[data-integy-v35-tag-filter], a.integy-v27-filter-chip').forEach(function (row) {
      var raw = rowHandle(row);
      if (!raw) return;
      var handle = canonical(index, raw);
      var known = !!(index.labels && index.labels[handle]);
      var anchor = row.matches && row.matches('a') ? row : qs('a', row);
      var isActive = active.indexOf(handle) >= 0 || row.getAttribute('data-filter-active') === 'true' || row.getAttribute('aria-current') === 'true';

      if (activePartType && filterGroup(handle) === 'part_type' && handle !== activePartType) {
        hideRow(row);
        return;
      }

      if (suppressedHandles[handle] && !isActive && !(data.counts && data.counts[handle])) {
        hideRow(row);
        return;
      }
      if (!known) return;
      if (shouldSuppressOption(
        index,
        collection,
        data,
        handle,
        (data.counts && data.counts[handle]) || 0,
        isActive
      )) {
        hideRow(row);
        return;
      }

      var nextTags = nextTagsForSelection(index, active, handle, isActive);
      var query = facetRecordsFor(index, collection, nextTags);
      var count = isActive ? facetRecordsFor(index, collection, active).records.length : query.records.length;
      row.setAttribute('data-integy-v307-option', handle);
      row.setAttribute('data-integy-v307-count', String(count));
      row.classList.remove('integy-v307-hidden-zero');
      row.style.display = '';
      if (!count && !isActive) {
        hideRow(row);
        return;
      }
      if (anchor) {
        anchor.href = buildUrl(collection, nextTags);
        anchor.setAttribute('data-integy-v294-direct-nav', '');
        anchor.setAttribute('data-integy-v307-direct-nav', '');
        anchor.setAttribute('aria-checked', isActive ? 'true' : 'false');
        anchor.setAttribute('data-tag-active', isActive ? 'true' : 'false');
      }
      qsa('[data-filtered-product-count], .filtered-product-count', row).forEach(function (countEl) {
        countEl.classList.remove('filtered-product-count--hidden');
        countEl.textContent = '(' + count + ')';
      });
    });
  }

  function zeroFallback(index, collection, tags) {
    var noResults = qs('.productgrid--no-results');
    if (!noResults) {
      noResults = document.createElement('div');
      noResults.className = 'productgrid--no-results integy-v307-zero-fallback';
      noResults.innerHTML =
        '<h2 class="productgrid--no-results-title"></h2>' +
        '<a class="productgrid--no-results-button" href=""></a>';
      var grid = qs('[data-productgrid-items], .productgrid--items');
      var wrapper = qs('.productgrid--wrapper, .productgrid--outer, main');
      if (grid && grid.parentNode) {
        grid.parentNode.insertBefore(noResults, grid.nextSibling);
      } else if (wrapper) {
        wrapper.appendChild(noResults);
      }
    }

    var labels = activeLabels(index, tags);
    var title = qs('.productgrid--no-results-title', noResults);
    var button = qs('.productgrid--no-results-button', noResults);
    if (title) {
      title.textContent = labels.length
        ? 'No products match this filter combination.'
        : 'No matching products are available.';
    }
    if (button) {
      button.href = buildUrl(collection, []);
      button.textContent = 'Back to all products in this collection';
    }
    noResults.style.display = '';
    root.classList.remove('integy-v307-filter-resolved');
    root.classList.add('integy-v307-filter-zero');
    if (document.body) {
      document.body.classList.remove('integy-v307-filter-resolved');
      document.body.classList.add('integy-v307-filter-zero');
    }
  }

  function hideNativeNoResults() {
    qsa('.productgrid--no-results').forEach(function (el) {
      el.style.display = 'none';
    });
  }


  function hideFilteredCard(card) {
    if (!card) return;
    card.setAttribute('data-integy-v307-hidden-mismatch', 'true');
    card.setAttribute('data-integy-v498-filter-hidden', 'true');
    card.setAttribute('aria-hidden', 'true');
    card.hidden = true;
    card.classList.add('integy-v498-filter-hidden');
    if (card.style) card.style.setProperty('display', 'none', 'important');
  }

  function showFilteredCard(card) {
    if (!card) return;
    card.removeAttribute('data-integy-v307-hidden-mismatch');
    card.removeAttribute('data-integy-v498-filter-hidden');
    card.removeAttribute('aria-hidden');
    card.hidden = false;
    card.classList.remove('integy-v498-filter-hidden');
    if (card.style) card.style.removeProperty('display');
  }

  function nativeCollectionCardCount() {
    var grid = qs('[data-productgrid-items], .productgrid--items');
    if (!grid) return 0;
    return qsa('[data-product-item], .productgrid--item', grid).filter(function (card) {
      return !card.hidden && !(card.getAttribute('data-integy-v307-hidden-mismatch') === 'true');
    }).length;
  }

  function pageLooksLikeEmptyCollection() {
    var noResults = clean((qs('.productgrid--no-results-title, .productgrid--no-results') || {}).textContent || '');
    var bodyText = clean(document.body ? document.body.textContent || '' : '');
    return /this collection is empty/i.test(noResults) || /this collection is empty/i.test(bodyText) || nativeCollectionCardCount() === 0;
  }

  function currentFilteredPage() {
    try {
      var page = parseInt(new URLSearchParams(location.search || '').get('page') || '1', 10);
      return Number.isFinite(page) && page > 0 ? page : 1;
    } catch (error) { return 1; }
  }

  function filteredPageHref(page) {
    try {
      var url = new URL(location.href);
      if (page > 1) url.searchParams.set('page', String(page)); else url.searchParams.delete('page');
      return url.pathname + (url.search || '');
    } catch (error) { return location.pathname + location.search; }
  }

  function renderFilteredPagination(total, page, grid) {
    qsa('.pagination--container,.pagination').forEach(function (pagination) {
      if (!pagination.classList.contains('integy-v426-filter-pagination')) {
        pagination.hidden = true;
        pagination.setAttribute('aria-hidden', 'true');
      }
    });
    qsa('.integy-v426-filter-pagination').forEach(function (pagination) { pagination.remove(); });
    var pageCount = Math.ceil(total / FILTER_PAGE_SIZE);
    if (!grid || pageCount <= 1) return;
    var nav = document.createElement('nav');
    nav.className = 'integy-v426-filter-pagination';
    nav.setAttribute('aria-label', 'Filtered product pages');
    var html = page > 1 ? '<a href="' + escapeHtml(filteredPageHref(page - 1)) + '" aria-label="Previous page">Previous</a>' : '';
    var visiblePages = [];
    if (pageCount <= 9) {
      for (var allPage = 1; allPage <= pageCount; allPage += 1) visiblePages.push(allPage);
    } else {
      var wanted = Object.create(null);
      [1, pageCount, page - 2, page - 1, page, page + 1, page + 2].forEach(function (candidate) {
        if (candidate >= 1 && candidate <= pageCount) wanted[candidate] = true;
      });
      visiblePages = Object.keys(wanted).map(function (value) { return parseInt(value, 10); }).sort(function (a, b) { return a - b; });
    }
    var previousVisible = 0;
    visiblePages.forEach(function (number) {
      if (previousVisible && number - previousVisible === 2) {
        var middle = previousVisible + 1;
        html += middle === page
          ? '<span aria-current="page">' + middle + '</span>'
          : '<a href="' + escapeHtml(filteredPageHref(middle)) + '">' + middle + '</a>';
      } else if (previousVisible && number - previousVisible > 2) {
        html += '<span class="integy-v628-pagination-ellipsis" aria-hidden="true">&hellip;</span>';
      }
      html += number === page
        ? '<span aria-current="page">' + number + '</span>'
        : '<a href="' + escapeHtml(filteredPageHref(number)) + '">' + number + '</a>';
      previousVisible = number;
    });
    if (page < pageCount) html += '<a href="' + escapeHtml(filteredPageHref(page + 1)) + '" aria-label="Next page">Next</a>';
    nav.innerHTML = html;
    grid.insertAdjacentElement('afterend', nav);
  }

  function renderRecords(index, collection, tags) {
    var result = recordsFor(index, collection, tags);
    var records = sortedRecords(result.records, result.collection || collection, result.tags || tags);
    var totalRecords = records.length;
    var pageCount = Math.max(1, Math.ceil(totalRecords / FILTER_PAGE_SIZE));
    var page = Math.min(currentFilteredPage(), pageCount);
    var pageRecords = records.slice((page - 1) * FILTER_PAGE_SIZE, page * FILTER_PAGE_SIZE);
    var key = collection + '|' + canonicalTags(index, tags).join('+') + '|stock:' + requestedStockMode();
    var stockRefill = null;
    if (indexedStockOwnerForCollection(collection) && requestedStockMode() !== 'all') {
      var fullResult = recordsFor(index, collection, tags, { stockSubset: false });
      var fullRecords = sortedRecords(fullResult.records, fullResult.collection || collection, fullResult.tags || tags);
      var preferred = Object.create(null);
      records.forEach(function (record) { var id = v576RecordIdentity(record); if (id) preferred[id] = true; });
      var fallback = fullRecords.filter(function (record) { var id = v576RecordIdentity(record); return id && !preferred[id]; });
      var rescueStart = (page - 1) * V576_STOCK_RESCUE_PER_PAGE;
      var rendered = Object.create(null);
      pageRecords.forEach(function (record) { var id = v576RecordIdentity(record); if (id) rendered[id] = true; });
      stockRefill = {
        key: key,
        index: index,
        collection: collection,
        tags: tags || [],
        page: page,
        grid: null,
        target: FILTER_PAGE_SIZE,
        rescuePool: fallback.slice(rescueStart, rescueStart + V576_STOCK_RESCUE_PER_PAGE),
        rescueIndex: 0,
        rendered: rendered,
        appended: 0
      };
    } else {
      v576StockRefillState = null;
    }
    if (!records.length) {
      var existingGrid = qs('[data-productgrid-items], .productgrid--items');
      if (existingGrid) {
        qsa('[data-product-item], .productgrid--item', existingGrid).forEach(function (card) {
          hideFilteredCard(card);
        });
        existingGrid.setAttribute('data-integy-v307-key', key);
        existingGrid.setAttribute('data-integy-v634-render-settled', 'true');
        if (indexedStockOwnerForCollection(collection) && requestedStockMode() !== 'all') {
          existingGrid.setAttribute('data-integy-v634-stock-settled', 'true');
          existingGrid.classList.remove('integy-v634-stock-settling');
        }
      }
      updateVisibleCounts(0, activeLabels(index, tags));
      qsa('.integy-v426-filter-pagination').forEach(function (pagination) { pagination.remove(); });
      ensureActiveChips(index, collection, tags);
      zeroFallback(index, collection, tags);
      root.classList.remove('integy-v648-model-pending');
      return;
    }
    var grid = ensureGrid();
    if (!grid) return;
    configureIndexedSortUi();
    /* INTEGY V634 — set render/stock settlement latches BEFORE the V307 render key.
       V594 previously saw the key mutation in this tiny window and could reveal
       a stale/empty grid before replaceChildren() or live stock verification. */
    grid.setAttribute('data-integy-v634-render-settled', 'false');
    if (stockRefill) {
      grid.setAttribute('data-integy-v634-stock-settled', 'false');
      grid.classList.add('integy-v634-stock-settling');
    } else {
      grid.removeAttribute('data-integy-v634-stock-settled');
      grid.classList.remove('integy-v634-stock-settling');
    }
    grid.setAttribute('data-integy-v307-key', key);
    if (stockRefill) {
      stockRefill.grid = grid;
      v576StockRefillState = stockRefill;
      grid.setAttribute('data-integy-v576-stock-refill', 'true');
      grid.removeAttribute('data-integy-v576-stock-refill-complete');
    }
    // V537: rebuild the visible grid in the exact pageRecords order. V536 kept
    // matching native cards in Shopify's current page order and appended missing cards,
    // which made Best selling/Featured/Most relevant appear to change the order even
    // though the indexed subset could only sort price/title accurately. Moving existing
    // nodes preserves their event state while guaranteeing exact indexed ordering.
    var existingByPath = Object.create(null);
    qsa('[data-product-item], .productgrid--item', grid).forEach(function (card) {
      var anchor = qs('a[href*="/products/"]', card);
      var path = anchor ? productPath(anchor.getAttribute('href') || '') : '';
      if (!path) return;
      if (!existingByPath[path]) existingByPath[path] = [];
      existingByPath[path].push(card);
    });
    var template = document.createElement('template');
    var ordered = document.createDocumentFragment();
    pageRecords.forEach(function (record, recordIndex) {
      var path = productPath(record.url || '');
      var card = path && existingByPath[path] && existingByPath[path].length ? existingByPath[path].shift() : null;
      if (!card) {
        template.innerHTML = cardHtml(record, recordIndex + 1);
        card = template.content.firstElementChild;
      }
      if (!card) return;
      showFilteredCard(card);
      card.setAttribute('data-integy-v307-card-index', String(recordIndex + 1));
      ordered.appendChild(card);
    });
    grid.replaceChildren(ordered);
    rewriteAllCardUrls(index, grid);
    v548VerifyNativeStockCards(grid);
    v528ObserveDynamicPrices(grid);
    window.setTimeout(function () { v576MaybeRefillStockGrid(grid); }, 0);
    renderFilteredPagination(totalRecords, page, grid);
    grid.setAttribute('data-integy-v634-render-settled', 'true');
    root.classList.remove('integy-v307-filter-zero');
    root.classList.add('integy-v307-filter-resolved');
    if (document.body) {
      document.body.classList.remove('integy-v307-filter-zero');
      document.body.classList.add('integy-v307-filter-resolved');
    }
    hideNativeNoResults();
    updateVisibleCounts(totalRecords, activeLabels(index, tags));
    ensureActiveChips(index, collection, tags);
    // V538: browser Back may restore scroll before this asynchronous grid rebuild.
    // Re-apply the saved card-relative position after the authoritative render.
    scheduleReturnPositionRestore(grid);
    root.classList.remove('integy-v648-model-pending');
    if (window.IntegyV648ModelPaintFailsafe) { window.clearTimeout(window.IntegyV648ModelPaintFailsafe); window.IntegyV648ModelPaintFailsafe = null; }
  }

  function enhanceEmptyState(collection, tags) {
    var noResults = qs('.productgrid--no-results');
    var grid = qs('[data-productgrid-items],.productgrid--items');
    var hasCards = grid && qsa('[data-product-item],.productgrid--item', grid).some(function (card) { return !card.hidden; });
    if (hasCards || !tags.length) return;
    if (!noResults) {
      noResults = document.createElement('section');
      noResults.className = 'productgrid--no-results integy-v426-empty-state';
      var wrapper = qs('.productgrid--wrapper,.productgrid--outer,main');
      if (wrapper) wrapper.appendChild(noResults);
    }
    var active = normalizeGroupTags({}, tags);
    var recent = active[active.length - 1];
    var previous = active.slice(0, -1);
    noResults.classList.add('integy-v426-empty-state');
    noResults.innerHTML = '<h2>No products match this filter combination</h2>' +
      '<p>Try removing the newest selection or choose one part type.</p>' +
      '<div class="integy-v426-empty-state__active">' + active.map(function (tag) { return '<span>' + escapeHtml(tag.replace(/-/g, ' ')) + '</span>'; }).join('') + '</div>' +
      '<div class="integy-v426-empty-state__actions">' +
        (recent ? '<a href="' + escapeHtml(buildUrl(collection, previous)) + '">Remove ' + escapeHtml(recent.replace(/-/g, ' ')) + '</a>' : '') +
        '<a href="' + escapeHtml(buildUrl(collection, [])) + '">Clear all filters</a>' +
        (collection === 'pinion-gears-for-rc' ? ['0-6-mod','0-8-mod','1-mod','32-pitch','48-pitch','64-pitch'] : ['wheel','shock','motor','esc']).map(function (part) { return '<a href="' + escapeHtml(buildUrl(collection, [part])) + '">View ' + part.replace(/(^|-)\w/g, function (letter) { return letter.toUpperCase(); }) + ' products</a>'; }).join('') +
      '</div>';
    root.classList.add('integy-v426-filter-zero');
    emitEvent('zero_result_filter_state', { collection: collection, filters: active });
  }

  function apply() {
    if (!document.body || !document.body.classList.contains('template-collection')) return;
    var path = pathData();
    if (!path.collection) return;
    if (repairCurrentUrl({})) return;
    repairFilterLinks({});
    /* INTEGY V643 — this canonical empty-state helper must not append UI to
       unrelated collections (notably large Sale/tag routes owned elsewhere). */
    if (!targetCollections[path.collection]) return;
    enhanceEmptyState(path.collection, path.tags);
    if (applying) return;
    applying = true;
    getIndex().then(function (index) {
      if (index) startCanonicalUrlObserver(index);
      if (repairCurrentUrl(index)) return;
      repairFilterLinks(index);
      var scoped = collectionData(index, path.collection);
      if (!scoped || !scoped.data) {
        hideEmptyCanonicalShell();
        markReady();
        return;
      }
      // V435: old generic tag URLs on the pinion collection (wheel, tire, shock,
      // bumper, body, servo-horn, etc.) are true zero-result routes. Remove them
      // instead of rendering a misleading empty collection.
      if (scoped.key === 'pinion-gears-for-rc' && path.tags.length) {
        var requestedPinionTags = canonicalTags(index, path.tags);
        var validPinionTags = requestedPinionTags.filter(function (handle) {
          return !!(scoped.data.counts && scoped.data.counts[handle]);
        });
        if (validPinionTags.length !== requestedPinionTags.length) {
          location.replace(buildUrl(scoped.key, validPinionTags));
          return;
        }
      }
      if (path.collection !== 'all') {
        renderCanonicalRows(index, scoped.key, scoped.data, path.tags);
        markFilterRows(index, scoped.key, scoped.data, path.tags);
      }
      markReady();
      var v536IndexedStock = !path.tags.length && indexedStockOwnerForCollection(path.collection) && requestedStockMode() !== 'all';
      root.classList.toggle('integy-v536-index-stock-owned', v536IndexedStock);
      if (v536IndexedStock) {
        renderRecords(index, scoped.key, []);
        emitEvent('integy:v429:filter-rendered', { collection: scoped.key, filters: [], stock: requestedStockMode() });
        return;
      }
      if (!path.tags.length) {
        if (forcedIndexedMembershipCollections[path.collection]) {
          root.classList.add('integy-v648-forced-model-membership');
          renderRecords(index, scoped.key, []);
          emitEvent('integy:v648:model-membership-rendered', { collection: scoped.key, count: (scoped.data.products || []).length, stock: requestedStockMode() });
          return;
        }
        /* V576: Shopify owns ordinary/base browsing except audited indexed stock routes. */
        root.classList.add('integy-v576-native-base-owner');
        if (scoped.data && scoped.data.products && scoped.data.products.length && pageLooksLikeEmptyCollection() && !v576MembershipRiskCollections[path.collection]) {
          renderRecords(index, scoped.key, []);
          emitEvent('integy:v576:empty-native-rescue', { collection: scoped.key, count: scoped.data.products.length });
        }
        return;
      }
      root.classList.add('integy-v536-index-stock-owned');
      renderRecords(index, scoped.key, path.tags);
      emitEvent('integy:v429:filter-rendered', { collection: scoped.key, filters: canonicalTags(index, path.tags) });
    }).catch(function () {
      return null;
    }).then(function () {
      applying = false;
    });
  }

  function directNavigation(event) {
    var anchor = event.target && event.target.closest
      ? event.target.closest('a[data-integy-v307-direct-nav]')
      : null;
    if (!anchor || !anchor.href || event.defaultPrevented) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    emitEvent(anchor.getAttribute('aria-checked') === 'true' ? 'filter_cleared' : 'filter_selected', {
      handle: anchor.getAttribute('data-integy-v307-option') || '',
      group: anchor.getAttribute('data-integy-v426-filter-group') || ''
    });
    location.assign(anchor.href);
  }

  function canonicalSortNavigation(event) {
    var target = event.target && event.target.closest
      ? event.target.closest('select[data-productgrid-trigger-sort], select[name="sort_by"], .utils-sortby-select, button[data-productgrid-trigger-sort-button]')
      : null;
    if (!target || event.defaultPrevented || !indexedOrderingActive()) return;
    var value = target.value || target.getAttribute('value') || '';
    if (!value) return;
    try {
      var url = new URL(location.href);
      url.searchParams.set('sort_by', value);
      url.searchParams.delete('page');
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      location.assign(url.pathname + (url.search || ''));
    } catch (error) {}
  }

  window.IntegyV501FilterOwner = window.IntegyV498FilterOwner = {
    apply: apply,
    recordsFor: recordsFor,
    canonicalTags: canonicalTags,
    reducedTags: reducedTags,
    filterGroup: filterGroup,
    normalizeGroupTags: normalizeGroupTags,
    nextTagsForSelection: nextTagsForSelection,
    normalizedCollectionUrl: normalizedCollectionUrl,
    trustedProductImage: trustedProductImage,
    displayType: displayType,
    cardHtml: cardHtml,
    ownsStockForCurrentCollection: ownsStockForCurrentCollection,
    indexedStockOwnerForCollection: indexedStockOwnerForCollection,
    indexedOrderingActive: indexedOrderingActive,
    exactIndexedSort: exactIndexedSort
  };

  function scheduleApply(delay) {
    window.setTimeout(apply, delay || 0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      [0, 350].forEach(scheduleApply);
    }, { once: true });
  } else {
    [0, 350].forEach(scheduleApply);
  }
  window.addEventListener('pageshow', function (event) {
    // V538: bfcache restores keep this JS instance alive, while non-bfcache Back
    // navigation is detected through PerformanceNavigationTiming. Arm restoration
    // before V501 rebuilds the indexed result set.
    if ((event && event.persisted) || navigationIsBackForward()) {
      armReturnPositionRestore(true);
    }
    scheduleApply(0);
    scheduleReturnPositionRestore();
  });
  document.addEventListener('shopify:section:load', function () { scheduleApply(0); });
  document.addEventListener('integy:v298:filters-ready', function () { scheduleApply(0); });
  // V538 capture-phase memory runs before the browser leaves for a product page.
  document.addEventListener('click', saveReturnPosition, true);
  document.addEventListener('click', filterLinkNavigation, true);
  document.addEventListener('click', directNavigation, true);
  document.addEventListener('keydown', filterKeyboardNavigation, true);
  document.addEventListener('change', canonicalSortNavigation, true);
  document.addEventListener('click', canonicalSortNavigation, true);
})();
